import { css, keyframes } from '@emotion/core'
import styled, { Theme, ThemeProps, TabProps } from '@themes/theme'
import { selectedMatchH } from '@views/Popup/Chat/ChatLiveScore/SelectLiveMatch/index.style'
import { TimelineMaxH, TimelineScoreH } from '@views/Popup/Chat/ChatLiveScore/LiveMatchTimeline/index.style'

// /////////////////////////////////////////// media qurey /////////////////////////////////////////////
//                    0    1    2    3    4    5     6     7     8     9
const breakpoints = [320, 410, 568, 768, 800, 1024, 1280, 1440, 1610, 1920]
//                      0
const pcBreakpoints = [1645] /* PC 컨텐츠 너비가 1645px을 차지함 */
//                     0    1    2    3     4
const breakpointsH = [568, 730, 810, 1024, 1366]

export const mq = breakpoints.map(bp => `@media (max-width: ${bp}px)`)
export const mqMin = breakpoints.map(bp => `@media (min-width: ${bp}px)`)
export const mqPC = breakpoints.map(bp => `@media (min-device-width: ${bp}px) `)
export const mqMinPCPopup = pcBreakpoints.map(bp => `@media (min-width: ${bp}px)`)
export const mqMinPortrait = breakpoints.map(bp => `@media (min-width: ${bp}px) and (orientation: portrait)`)
export const mqMinLandscape = breakpoints.map(bp => `@media (min-width: ${bp}px) and (orientation: landscape)`)

export const mqH = breakpointsH.map(bp => `@media (max-height: ${bp}px)`)
export const mqMinH = breakpointsH.map(bp => `@media (min-height: ${bp}px)`)
// PC 버전 (컨텐츠 너비 1610px)
export const PCMaxWidth = '1645px'
export const PCModalMaxWidth = '414px'
export const ModalOpacityValue = 'opacity .15s'
// /////////////////////////////////////////// base css /////////////////////////////////////////////
export const FontXLarge = '2.0rem'
export const FontTitle = '1.6rem'
export const FontLarge = '1.4rem'
export const FontMedium = '1.2rem'
// export const FontSmall = '1rem'
export const FontTiny = '0.8rem'

export const FloatingBottomNoNav = '21px'
export const FloatingBottom = '90px'
export const FloatingBottom2 = '148px'
export const SafeAreaEnvPadding = 'calc(env(safe-area-inset-bottom) - 18px)'
export const SafeAreaConstantPadding = 'calc(constant(safe-area-inset-button) - 18px)'

export const NavH = '63px'
export const NavBottomPadding = `calc(${NavH} + 60px)`

export const PCFloatingRightBtnPosition = '649px'
export const PCFloatingRightBtnPositionMqMin = 'translateX(-147%)'

export const preventScrollStyle = 'overscroll-behavior: none;' /* 스크롤 체이닝 방지 */
export const btnInitializationStyle = 'border-radius: 0;' /* IOS15 라운드스타일 초기화 */

// 종목탭
const sportTabH = '89px'
const matchLeagueTabH = '40px'

const stickyMatchTabTop = '39px'
const stickyMatchChildTabTop = `calc(${stickyMatchTabTop} + ${sportTabH})`

const liveDetailBetradarH = '97px'
const liveDetailStatScoreH = '59px'

export const Show = css`
  display: block;
`
export const Hide = css`
  display: none;
`
export const opacityAni = keyframes`
  0% {
    opacity: .4;
  }
  100% {
    opacity: 0;
  }
`
export const ShowAni = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`
export const HideAni = keyframes`
  0% {
    opacity: 1;
  }
  90% {
    opacity: 0;
  }
  100% {
    opacity: 0;
    display: none;
  }
`
export const ShowPopoverAni = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: .4;
  }
`
export const ModalHeightAni = keyframes`
  0% {
    height: auto;
  }
  100% {
    height: 100%;
  }
`
export const ShowHidden = keyframes`
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0.6;
  }

  100% {
    opacity: 1;
  }
`
export const favoriteNumAni = keyframes`
  0% {
    opacity: 1;
    top: -7px;
  }
  30% {
    opacity: 1;
  }
  95% {
    opacity: 0;
  }
  100% {
    opacity: 0;
    top: -15px;
  }
`
const betDetailTabAni = keyframes`
  0% {
    top: 0;
  }
  100% {
    top: 39px;
  }
`
const favoriteTabAni = keyframes`
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
`
// 라이브 비주얼라이제이션 스크롤 시 탭 연출
const betDetailBetradarLiveTabAni = keyframes`
  0% {
    top: 0;
  }
  100% {
    top: calc(${liveDetailBetradarH} - 1px);
  }
`
const betDetailStatScoreLiveTabAni = keyframes`
  0% {
    top: 0;
  }
  100% {
    top: calc(${liveDetailStatScoreH} - 1px);
  }
`
export const ChatArea = css`
  display: inline-block;
  width: 100%;
  margin-bottom: 40px;
`
export const CommonTxtBoxStyle = css`
  word-break: break-word;
  white-space: pre-wrap;
`
// 보여지는 글자수 제한
export const CommonLimitStyle = css`
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
`
export const TxtLimit = css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
export const TxtLimitPreWrap = css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
`
export const TxtLimit2 = css`
  ${CommonTxtBoxStyle};
  ${CommonLimitStyle};
  -webkit-line-clamp: 2;
  max-height: 2.4rem;
`
export const TxtLimit3 = css`
  ${CommonTxtBoxStyle};
  ${CommonLimitStyle};
  -webkit-line-clamp: 3;
  max-height: 3.6rem;
`
// input 공통
export const Form = styled.form`
  position: relative;
  width: 100%;
`
export const Input = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  border: 0;
  clip: rect(0, 0, 0, 0);
`

// /////////////////////////////////////////// select /////////////////////////////////////////////
export const SelectStyle = (props: ThemeProps) => css`
  .ant-select {
    top: 10px;
    float: right;
    width: 110px;
    line-height: 3rem;
  }
  .ant-select-selection {
    height: 24px;
    background: ${props.theme.color.contentsBg};
    border: 1px solid ${props.theme.color.gray};
    border-radius: 50px;
    *:not(.ant-select-selection__rendered) {
      background: ${props.theme.color.contentsBg} !important;
    }
    &:hover {
      border-color: ${props.theme.color.primary};
    }
  }
  .ant-select-selection__rendered {
    height: 24px;
    .ant-select-selection-selected-value {
      height: 20px;
    }
  }
  .ant-select-arrow .ant-select-arrow-icon {
    display: none;
  }
  .ant-select-selection-selected-value {
    height: 24px;
    font-size: ${props.theme.font.small};
    background: ${props.theme.color.contentsBg};
  }
  /* tab안에 있는 select */
  .tab-select.ant-select {
    z-index: 2;
    position: absolute !important;
    top: 3px;
    right: 20px;
    .ant-select-selection__rendered {
      line-height: 2.4rem;
    }
  }
`
// /////////////////////////////////////////// text /////////////////////////////////////////////
// title 공통
export const LobbyTitleWrap = styled.div`
  height: 50px;
  margin-bottom: 5px;
  padding: 20px 5px 0 20px;
  line-height: 3.2rem;
  background: ${props => props.theme.color.TP};
`
// 페이지별 타이틀
export const TitleWrap = styled.header`
  position: relative;
  display: flex;
  height: 34px;
  padding: 0 14px;
  line-height: 3.4rem;
  background: #1c202b;
  &.flex {
    display: flex;
    justify-content: space-between;
  }
  &.matchup-detail {
    &.pc {
      justify-content: center;
    }
  }
  &.sticky {
    z-index: 2;
    position: sticky;
    top: 40px;
  }
  &.no-bg {
    z-index: 2;
    background: none;
  }
  &.no-header {
    height: 60px;
    line-height: 6rem;
    margin-top: -40px;
  }
  &.white {
    height: 46px;
    line-height: 4.6rem;
    background: ${props => props.theme.color.modalBg};
    svg {
      .fill {
        fill: ${props => props.theme.color.modalTxt};
      }
    }
  }
  &.theme-txt-color {
    height: 46px;
    line-height: 4.6rem;
    background: ${props => props.theme.color.themeTxt};
    svg {
      .fill {
        fill: ${props => props.theme.color.modalTxt};
      }
    }
  }

  &.itemshop-mo {
    justify-content: space-between;
  }
  &.itemshop-pc {
    justify-content: flex-end;
  }
  &.guide-tit {
    svg {
      path {
        fill: ${props => props.theme.color.themeTxt};
      }
    }
  }
  &.modal-tit {
    margin-top: 40px;
    .page-tit {
      font-size: ${props => props.theme.font.title};
    }
    &.pc-tit.title-wrap {
      height: 60px;
      line-height: 60px;
      margin-top: 0;
    }
  }
  &.user-pick-filter {
    margin-top: 20px;
    top: 20px;
    & + .filter {
      top: 54px;
    }
  }
  // 경기결과 페이지 타이틀과 매치업 탭을 동일선상에 위치시키기 위한 별도의 스타일입니다. 
  &.result-page {
    height: 46px;
    margin-top: 12px;
    align-items: center;
    .title {
      font-size: 17px;
    }
    .back-btn {
      width: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: -20px;
      padding-bottom: 20px;
      z-index: 4;
    }
  }
`
export const Title = styled.h1`
  display: inline-block;
  color: ${props => props.theme.color.themeTxt};
  font-size: ${props => props.theme.font.large};
`
export const ContentWrap = styled.section`
  position: relative;
  display: block;
  height: auto;
  /* margin-bottom: 40px; */
  padding: 10px 17px;
  background: ${props => props.theme.color.contentsBg};
  /* box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1); */
  &.no-padding {
    padding: 0;
  }
  &.no-bg {
    background: none;
  }
  &.telegram-guide-wrap {
    padding: 0;
    background: ${props => props.theme.color.mainBg};
  }
  .detail-bet-delay {
    opacity: 0;
    animation: ${ShowAni} .1s 1 forwards cubic-bezier(.72, .26, .05, .88);
    animation-delay: .25s;
    &.pc {
      opacity: 1;
      animation: none;
    }
  }
  &.white {
    background: ${props => props.theme.color.modalBg};
  }
  // 상세 BET_컨텐츠 탭(BET, 매치정보, 분석글, 응원글) + 상세 BET_BET 하위탭 
  .matchup-detail {
    position: sticky;
    top: -1px;
    z-index: 1;
    background: ${props => props.theme.color.mainBg};
    overflow: hidden;
    &.show-simple-info {
      animation: ${betDetailTabAni} .15s 1 forwards cubic-bezier(.02, .67, .48, 1);
    }
    &.live-score-tab.betradar {
      animation: ${betDetailBetradarLiveTabAni} .15s 1 forwards cubic-bezier(.02, .67, .48, 1);
    }
    &.live-score-tab.statscore {
      animation: ${betDetailStatScoreLiveTabAni} .15s 1 forwards cubic-bezier(.02, .67, .48, 1);
    }
    .num {
      min-width: auto;
    }
    &.matcup-filter {
      top: 39px;
      &.show-simple-info, &.live-score-tab.betradar, &.live-score-tab.statscore {
        padding-top: 40px;
        margin-top: -40px; // 컨텐츠탭 하위에 발생하는 여백으로 인해 추가한 코드입니다.
      }
    }
    .am-tabs-default-bar-tab-active {
      .pick-badge-tab {
        opacity: 1;
      }
    }
    // 상세 BET_컨텐츠 탭(BET, 매치정보, 분석글, 응원글)
    &.content-tab {
      z-index: 2;
      .am-tabs-default-bar-tab {
        height: 44px;
        .tab-item {
          .txt {
            font-size: ${props => props.theme.font.large};
          }
        }
      }
    }
  }
  .detail-bet-contents-wrap {
    height: 100%;
    .render-contents-wrap {
      width: 100%;
      min-height: 100vh;
      text-align: center;
      position: static;
      &:not(:has( > .match-detail)) {
        background: ${props => props.theme.color.mainColor};
      }
      // 컨텐츠탭_매치정보
      .stat-visualization {
        height: 5000px;
        &.large {
          height: 9000px;
        }
      }
      .empty-wrap {
        top: 40%;
      }
      .am-list-view-scrollview-content {
        position: static !important;
        .am-list-body {
          margin: 0;
          background: ${props => props.theme.color.mainColor};
        }
        .am-list-footer {
          margin: 0;
          padding-bottom: ${NavBottomPadding};
        }
      }
    }
  }
`
export const ModalLoading = styled.div`
  position: relative;
  top: -45px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: ${props => props.theme.color.mainBg};
`
export const ContentTitle = styled.h2`
  position: relative;
  padding-bottom: 10px;
  color: ${props => props.theme.color.themeTxt};
  font-size: ${props => props.theme.font.medium};
  &::after {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 200%;
    border-bottom: ${props => props.theme.border.line};
    transform: translate(-50%, 0);
  }
`
// Text 정렬
export const TxtCenter = css({
  textAlign: 'center',
})
export const TxtLeft = css`
  text-align: left;
`
export const TxtRight = css({
  textAlign: 'right',
})
export const Left = css`
  float: left;
  text-align: left;
`
export const Right = css`
  float: right;
  text-align: right;
`
export const PopoverWrap = styled.div`
  z-index: 1;
  width: 60vw;
  p,
  span {
    display: inline-block;
    font-size: ${props => props.theme.font.small};
    animation: ${ShowAni} 0.55s ease-in-out;
  }
  p {
    max-width: 58vw;
    margin-left: 12px;
  }
  span {
    position: absolute;
    top: 0;
  }
`
export const PopoverTxt = styled.p`
  margin-left: 0 !important;
  font-size: ${props => props.theme.font.small};
  line-height: 1.4rem;
`
export const InfoGreenStyle = styled.span`
  position: relative;
  top: 2px;
  left: 6px;
  width: 14px;
  svg path {
    fill: ${props => props.theme.color.primary};
  }
`
export const PopoverStyle = (theme: Theme) => css`
  position: absolute;
  left: 0;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  border: 0;
  clip: rect(0, 0, 0, 0);
  & + label {
    position: relative;
    display: inline-block;
    width: 30px;
    height: 34px;
    line-height: 3.4rem;
    overflow: hidden !important;
    .popover-txt-wrap {
      opacity: 0;
      display: none;
      z-index: 1;
      position: relative;
      top: 2px;
      left: -25px;
      width: 0;
      height: 0;
      color: ${theme.color.modalTxt};
      font-size: ${theme.font.small};
      &::before {
        opacity: 0;
        z-index: -1;
        content: '';
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        width: inherit;
        height: 38px;
        transform: translate(-50%, -50%);
        background: ${theme.color.themeTxt};
        border-radius: 15px;
      }
      &::after {
        opacity: 0;
        z-index: -2;
        content: '';
        display: block;
        position: absolute;
        top: -2px;
        left: 28px;
        width: 20px;
        height: 0;
        border-top: 11px solid transparent;
        border-bottom: 11px solid ${theme.color.themeTxt};
        border-right: 11px solid transparent;
        border-left: 11px solid ${theme.color.themeTxt};
        transform: rotate(135deg);
      }
      .popover-txt {
        opacity: 0;
        z-index: 2;
        position: absolute;
        float: left;
        top: 50%;
        left: 50%;
        width: 240px;
        height: auto;
        color: ${theme.color.modalTxt};
        font-size: ${theme.font.small};
        transform: translate(-50%, -50%);
        ${TxtLimit2};
      }
    }
  }
  &:checked + label {
    overflow: visible !important;
    .popover-txt-wrap {
      /* opacity: 1; */
      display: block;
      width: 260px;
      height: 34px;
      animation: ${ShowAni} 0.3s forwards;
      &::before,
      &::after {
        opacity: 1;
      }
      .popover-txt {
        opacity: 1;
      }
    }
  }
`
export const LetterSpace = css`
  letter-spacing: -0.02rem;
`
const PointStyle = (props: ThemeProps) => css`
  position: relative;
  font-size: ${props.theme.font.medium};
  color: ${props.theme.color.primary};
`
export const Point = styled.span`
  ${PointStyle};
  color: ${props => (props.primary ? props.theme.color.primary : props.theme.color.yellow)};
  &.hit {
    color: ${props => props.theme.color.blue} !important;
  }
  &.important {
  }
  &.modal {
    color: ${props => props.theme.color.secondaryBg} !important;
    &.important {
      color: ${props => props.theme.color.modalred} !important;
    }
  }
`

// /////////////////////////////////////////// Tab /////////////////////////////////////////////
export const CenterTabWrap = styled.div`
  position: relative;
  .am-tabs {
    align-items: center;
  }
  .am-tabs-tab-bar-wrap {
    width: 50%;
  }
  .am-tabs-default-bar-tab {
    height: 42px;
    cursor: pointer;
    span {
      opacity: .4;
      color: ${props => props.theme.color.themeTxt};
      font-size: ${props => props.theme.font.title};
      transition: all 0.3s;
    }
    &:not(:first-of-type) {
      position: relative;
      &::before {
        content: '';
        display: block;
        position: absolute;
        top: 50%;
        left: 0;
        width: 1px;
        height: 16px;
        transform: translateY(-50%);
        border-left: 1px solid ${props => props.theme.color.btn};
        opacity: .5;
      }
    }
  }
  .am-tabs-default-bar-tab-active {
    background: none;
    span {
      opacity: 1;
    }
    .special-txt svg {
      opacity: 1;
    }
  }
  .am-tabs-default-bar-underline {
    display: none;
  }
  &.white-bg {
    background: ${props => props.theme.color.themeTxt};
    .am-tabs-default-bar-tab {
      span {
        opacity: .4;
        color: ${props => props.theme.color.modalTxt};
      }
      &:not(:first-of-type) {
        position: relative;
        &::before {
          content: '';
          display: block;
          position: absolute;
          top: 50%;
          left: 0;
          width: 1px;
          height: 16px;
          transform: translateY(-50%);
          border-left: 1px solid ${props => props.theme.color.btn};
          opacity: .5;
        }
      }
    }
    .am-tabs-default-bar-tab-active {
      background: none;
      span {
        opacity: 1;
      }
      .special-txt svg {
        opacity: 1;
      }
    }
  }
  &.guide-tab {
    .am-tabs-tab-bar-wrap {
      width: 60%;
    }
  }
  &.my-page {
    background: ${props => props.theme.color.TP};
    .am-tabs-tab-bar-wrap {
      width: 172px;
      .am-tabs-default-bar-tab {
        span {
          opacity: 1;
          color: ${props => props.theme.color.modalDarkBg};
        }
        &:not(:first-of-type) {
          position: relative;
          &::before {
            content: '';
            display: block;
            position: absolute;
            top: 50%;
            left: 0;
            width: 1px;
            height: 16px;
            transform: translateY(-50%);
            border-left: 1px solid ${props => props.theme.color.gray};
          }
        }
      }
      .am-tabs-default-bar-tab-active {
        span {
          color: ${props => props.theme.color.modalTxt};
        }
      }
    }
  }
`
export const LeftTabWrap = styled.div`
  position: relative;
  &.match-tab-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 7px;
    margin-top: 16px;
  }
  // 마이페이지 나의활동 탭
  &.white-bg {
    .am-tabs {
      margin-left: -15px;
      &-default-bar {
        &-tab {
          &-active {
            .txt {
              color: ${props => props.theme.color.modalTxt};
            }
          }
        }
      }
    }
  }
  .am-tabs {
    align-items: flex-start;
    &.match-tab {
      display: inline-flex;
      width: auto;
    }
    &-default-bar {
      &-tab {
        width: auto !important;
        height: 42px;
        padding: 8px 11px;
        cursor: pointer;
        .txt {
          color: ${props => props.theme.color.disableTxt2};
          font-size: ${props => props.theme.font.largeNum};
          transition: all 0.3s;
          &.live-txt {
            display: inline-block;
            min-width: 45px;
          }
        }
        .am-badge {
          opacity: .4;
        }
        &:not(:first-of-type) {
          position: relative;
          &::before {
            content: '';
            display: block;
            position: absolute;
            top: 50%;
            left: 0;
            width: 1px;
            height: 16px;
            transform: translateY(-53%);
            border-left: 1px solid ${props => props.theme.color.btn};
            opacity: .7;
          }
        }
        &-active {
          background: none;
          .txt {
            color: ${props => props.theme.color.themeTxt};
          }
          .am-badge {
            opacity: 1;
          }
        }
      }
      &-underline {
        display: none;
      }
    }
  }
  .button-wrap {
    display: flex;
    gap: 12px;
    margin: 0 auto 0 2px;
  }
`
export const UnderLineTabWrap = styled.div`
  .am-tabs {
    align-items: center;
    background: ${props => props.theme.color.mainBg};
    &::before {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 1px;
      border-bottom: 1px solid ${props => props.theme.color.btn};
      opacity: .5;
    }
  }
  .am-tabs-tab-bar-wrap {
    width: calc(100% - 14px);
  }
  .am-tabs-default-bar-tab {
    height: 40px;
    cursor: pointer;
    span {
      position: relative;
      color: ${props => props.theme.color.disableTxt};
      font-size: ${props => props.theme.font.medium};
      transition: all .3s;
      overflow: visible;
      &.sports {
        width: 100%;
        text-align: center;
        border-radius: 10px;
        transition: none;
        padding: 0 6px;
        &.ice-hockey {
          min-width: 60px;
          white-space: nowrap;
        }
      }
    }
  }
  .am-tabs-default-bar-tab-active {
    span {
      color: ${props => props.theme.color.themeTxt};
    }
    position: relative;
    &::before {
      content: '';
      display: block;
      position: absolute;
      bottom: 1px;
      left: 50%;
      transform: translateX(-50%);
      width: calc(100% - 32px);
      height: 2px;
      background: ${props => props.theme.color.underover};
    }
  }
  .am-tabs-default-bar-underline {
    display: none;
  }
  &.match-child-tab {
    z-index: 3;
    position: sticky;
    top: ${stickyMatchTabTop}; /* header 높이 보다 -1한 값 */
    width: 100%;
    .am-tabs-default-bar-tab {
      width: auto !important;
      flex: 1;
    }
    &.fixed-tab {
      position: fixed;
    }
  }
  &.black-line {
    .am-tabs {
      background: ${props => props.theme.color.modalBg};
      &::before {
        border-bottom: 1px solid ${props => props.theme.color.gray};
      }
    }
    .am-tabs-default-bar-tab {
      span {
        font-size: ${props => props.theme.font.large};
      }
    }
    .am-tabs-default-bar-tab-active {
      span {
        color: ${props => props.theme.color.mainBg};
      }
      &::before {
        border: 1px solid ${props => props.theme.color.mainBg};
      }
    }
  }
  // 친구초대 탭
  &.friends-tab {
    background: #fff;
    .am-tabs {
      background: none;
      &::before {
        border-color: #F0F1F5;
      }
    }
    .am-tabs-default-bar-tab {
      display: flex;
      flex-flow: column;
      justify-content: center;
      align-items: center;
      height: 63px;
      line-height: 18px;
      .txt {
        color: #C7C3D1;
        font-size: ${props => props.theme.font.largeNum};
      }
      .num {
        color: #DAD6E6;
        font-weight: ${props => props.theme.fontW.medium};
      }
    }
    .am-tabs-default-bar-tab-active {
      &::before {
        height: 3px;
        background: #8751FA;
      }
      .txt {
        color: #22104B;
      }
      .num {
        color: #AAA2BC;
      }
    }
  }
`
export const TabWrap = styled.div`
  /* border: 1px solid red; */
  .am-tabs-default-bar-tab {
    height: 36px;
    cursor: pointer;
    span {
      color: ${props => props.theme.color.gray};
      font-size: ${props => props.theme.font.medium};
      transition: all 0.3s;
    }
  }
  .am-tabs-default-bar-tab-active {
    span {
      color: ${props => props.theme.color.themeTxt};
    }
    .special-txt svg {
      opacity: 1;
    }
  }
  .am-tabs-default-bar-underline {
    z-index: -1;
    width: 100%;
    height: 36px;
    background: ${props => props.theme.color.contentsBg};
    border: none;
    border-radius: 10px 10px 0 0;
    transition: none;
  }

  /* 오즈타입 탭 (스포츠/라이브) */
  &.match-tab {
    .am-tabs-default-bar-tab {
      height: 33px;
    }
    .am-tabs-default-bar-underline {
      height: 33px;
      background: ${props => props.theme.color.tabBg} !important;
    }
    .am-tabs-default-bar-top .am-tabs-default-bar-content,
    .am-tabs-default-bar-bottom .am-tabs-default-bar-content {
      position: relative;
      margin: 0 auto;
      justify-content: space-between;
    }
    .am-tabs .am-tabs-default-bar-tab {
      &:nth-of-type(3) {
        /* width: 30% !important; */
      }
    }
  }
  /* 이벤트 팝업 tab */
  &.event {
    .am-tabs .am-tabs-tab-bar-wrap .am-tabs-default-bar {
      background: ${props => props.theme.color.TP} !important;
      &::after {
        display: none;
      }
      .am-tabs-default-bar-content {
        justify-content: flex-start;
      }
    }
    .am-tabs-default-bar-underline {
      display: none;
    }
    .am-tabs-default-bar-tab {
      span {
        color: ${props => props.theme.color.gray};
      }
    }
    .am-tabs-default-bar-tab-active span {
      color: ${props => props.theme.color.themeTxt};
    }
  }
`
const SpinSportIcoAni = keyframes`
  0% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(720deg);
  }
`
export const ChildTabWrap = styled.div`
  .am-tabs .am-tabs-tab-bar-wrap .am-tabs-default-bar {
    background: ${props => props.theme.color.contentsBg} !important;
  }
  .am-tabs-default-bar-tab {
    height: 36px;
    cursor: pointer;
    span {
      color: ${props => props.theme.color.gray};
      font-size: ${props => props.theme.font.medium};
      transition: all .3s;
      &.sports {
        .txt {
          display: block;
        }
        svg {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          display: none;
          width: 16px;
        }
      }
    }
  }
  .am-tabs-default-bar-tab-active {
    span {
      color: ${props => props.theme.color.primary};
      &.today, &.sports {
        background: ${props => props.theme.color.mainBg};
        opacity: 1;
        transition: none;
      }
      &.sports {
        .txt {
          display: none;
        }
        svg {
          display: block;
          animation: ${SpinSportIcoAni} 3s infinite linear;
        }
        &.ice-hockey {
          svg {
            animation: none;
          }
        }
      }
    }
  }
  .am-tabs-default-bar-underline {
    display: none;
    transition: none;
  }
  &.special-match-child-tab {
    .am-tabs .am-tabs-tab-bar-wrap .am-tabs-default-bar {
      background: ${props => props.theme.color.tabBg} !important;
    }
    .am-tabs-default-bar-tab {
      width: auto !important;
      height: 33px;
      margin-right: 14px;
    }
    .am-tabs-default-bar-top .am-tabs-default-bar-content, .am-tabs-default-bar-bottom .am-tabs-default-bar-content {
      width: 65%;
      margin-left: 14px;
    }
    /* 스페셜 결과 내역 탭 */
    &.betting-history {
      .am-tabs .am-tabs-tab-bar-wrap .am-tabs-default-bar {
        background: ${props => props.theme.color.contentsBg} !important;
      }
      .am-tabs-default-bar-top .am-tabs-default-bar-content, .am-tabs-default-bar-bottom .am-tabs-default-bar-content {
        margin-left: 10px;
        width: 38%;
      }
    }
  }
  /* 아이템 샵 */
  &.item-shop {
    .am-tabs-default-bar-top .am-tabs-default-bar-content, .am-tabs-default-bar-bottom .am-tabs-default-bar-content {
      /* width: 80%; */
    }
    .am-tabs-default-bar-tab {
      height: 42px;
    }
  }
`
export const WhiteTabWrap = styled.div`
  .am-tabs-default-bar-tab {
    height: 33px;
    cursor: pointer;
    background: ${props => props.theme.color.modalDarkBg};
    border-radius: 10px 10px 0 0;
    span {
      color: ${props => props.theme.color.modalSubTxt};
      font-size: ${props => props.theme.font.large};
      transition: all 0.3s;
    }
  }
  .am-tabs-default-bar-tab-active {
    background: ${props => props.theme.color.modalBg};
    span {
      color: ${props => props.theme.color.mainBg};
    }
    .special-txt svg {
      opacity: 1;
    }
  }
  .am-tabs-default-bar-underline {
    display: none;
  }
  &.item-shop-tab {
    z-index: 2;
    position: sticky;
    top: 147px;
    &.pc {
      top: 107px;
    }
  }
`
export const WhiteChildTabWrap = styled.div`
  position: relative;
  .am-tabs .am-tabs-tab-bar-wrap .am-tabs-default-bar {
    background: ${props => props.theme.color.modalBg} !important;
    .am-tabs-default-bar-content {
      width: auto;
    }
  }
  &.tp {
    .am-tabs .am-tabs-tab-bar-wrap .am-tabs-default-bar {
      background: ${props => props.theme.color.TP} !important;
    }
  }
  .am-tabs-default-bar-tab {
    height: 42px;
    cursor: pointer;
    padding: 0 12px;
    &::before {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: calc(100% - 20px);
      height: 3px;
      background: none;
    }
    span {
      width: 110%;
      color: ${props => props.theme.color.modalSubTxt};
      font-size: ${props => props.theme.font.medium};
      transition: all .3s;
    }
  }

  .am-tabs-default-bar-tab-active {
    &::before {
      background: ${props => props.theme.color.mainBg}
    }
    span {
      color: ${props => props.theme.color.mainBg};
      font-weight: ${props => props.theme.fontW.bold};
    }
  }

  .am-tabs-default-bar-underline {
    display: none;
  }

  &.light {
    .am-tabs .am-tabs-tab-bar-wrap .am-tabs-default-bar {
      padding: 12px 14px 0;
      background: ${props => props.theme.color.themeTxt} !important;
    }
    .txt, .num {
      color: ${props => props.theme.color.gray};
    }
    .am-tabs-default-bar-tab-active {
      &::before {
        background: ${props => props.theme.color.mainBg}
      }
      span {
        font-weight: ${props => props.theme.fontW.bold};
      }
      .txt {
        color: ${props => props.theme.color.mainBg};
      }
      .num {
        color: ${props => props.theme.color.modalOrange};
      }
    }
  }
  // 채팅 탭
  &.chat-tab-wrap {
    flex: 1;
    overflow: hidden;
    background: ${props => props.theme.color.modalBg};
    .am-tabs-tab-bar-wrap {
      padding: 0 14px;
      border-bottom: 1px solid ${props => props.theme.color.modalSubBg};
    }
    .am-tabs-content-wrap {
      touch-action: auto !important; /* antd 기본값: pan-x pan-y */
    }
    .am-tabs-pane-wrap {
      z-index: 1;
      overflow-x: hidden;
      overflow-y: auto;
      &::-webkit-scrollbar {
        display: block !important; /* 팝업내 스크롤바 보이도록 */
      }
    }
    .am-tabs-default-bar-tab {
      width: auto !important;
      height: 50px;
      span {
        font-size: ${props => props.theme.font.small};
        color: ${props => props.theme.color.modalgray};
      }
    }
    .am-tabs-default-bar-tab-active {
      span {
        color: ${props => props.theme.color.modalTxt};
      }
    }
    &.close {
      display: none;
    }
  }
  // PC버전 채팅
  &.pc-chat-tab {
    .am-tabs-tab-bar-wrap {
      padding: 0 14px 0 4px;
    }
    .am-tabs-default-bar-tab {
      padding: 0 8px;
    }
  }
  // 베팅슬립 탭
  &.betslip-tab {
    width: 100%;
    .am-tabs .am-tabs-tab-bar-wrap .am-tabs-default-bar {
      background: ${props => props.theme.color.themeTxt} !important;
    }
    .am-tabs-tab-bar-wrap {
      margin-bottom: 42px;
      background: ${props => props.theme.color.themeTxt};
      .am-tabs-default-bar-tab span {
        color: ${props => props.theme.color.gray};
      }
      // 다이아 svg
      svg:first-of-type {
        opacity: .6;
      }
      .am-tabs-default-bar-tab-active {
        svg {
          opacity: 1;
        }
        span {
          color: ${props => props.theme.color.modalTxt};
          &.dia-tab-txt {
            color: ${props => props.theme.color.secondaryBg};
          }
        }
      }
    }
    .am-tabs-tab-bar-wrap {
      z-index: 0;
      padding: 0 14px;
      border-bottom: 1px solid ${props => props.theme.color.modalSubBg};
    }
  }
  // 채팅 상단 라이브 경기 탭
  &.chat-live-match-tab {
    .am-tabs {
      overflow: visible; /* tab sticky 속성 적용시키기 위해 */
      .am-tabs-tab-bar-wrap {
        position: sticky;
        top: calc(${selectedMatchH} - 1px);
        left: 0;
        z-index: 1;
        padding-top: 13px;
        background: ${props => props.theme.color.themeTxt};
        border-bottom: 1px solid ${props => props.theme.color.modalBg};
      }
      .am-tabs-content-wrap {
        overflow: hidden;
      }
      .am-tabs-tab-bar-wrap .am-tabs-default-bar .am-tabs-default-bar-content {
        width: 100%;
      }
    }
  }
  // 채팅 상단 라이브 경기 타임라인 탭
  &.live-timeline-tab {
    .am-tabs {
      max-height: calc(${TimelineMaxH} - ${TimelineScoreH});
      overflow-y: visible;
      .am-tabs-tab-bar-wrap {
        position: sticky;
        top: 0;
        z-index: 1;
        padding: 0 6px;
        background: ${props => props.theme.color.themeTxt};
        border-bottom: 1px solid ${props => props.theme.color.modalBg};
      }
      .am-tabs-default-bar-content {
        max-width: 100%;
      }
      .am-tabs-pane-wrap {
        overflow: visible;
      }
    }
  }
`
/* tab 안에 switch button */
export const SwitchWrap = styled.div`
  z-index: 1;
  position: absolute;
  top: 5px;
  right: 12px;
  width: 95px;
  color: ${props => props.theme.color.themeTxt};
  font-size: ${props => props.theme.font.small};
  .switch-btn {
    position: relative;
    top: -1px;
    left: 6px;
    color: ${props => props.theme.color.themeTxt};
    font-size: ${props => props.theme.font.small};
    &.ant-switch-checked {
      background-color: ${props => props.theme.color.primary};
    }
  }
`
export const OzTabWrap = styled.section``

export const SpecialBtnStyle = (theme: Theme) => css`
  z-index: 1;
  position: absolute;
  top: 3px;
  right: 15px;
  padding: 0 10px;
  color: ${theme.color.themeTxt};
  font-size: ${theme.font.small};
`
// 종목 탭 하위 영역
const StickyChildTab = css`
  z-index: 2;
  position: sticky;
  top: ${stickyMatchChildTabTop}; /* header 높이 보다 -1한 값 + match-tab 높이 보다 -1한 값 */
  transition: all .15s;
`

const RoundTabHeight = '54px'
const roundTabStyle = (props: TabProps) => css`
  .am-tabs-default-bar-content {
    padding: 0 14px;
  }
  .am-tabs-default-bar {
    background: ${props.theme.color.mainBg};
    overflow-x: auto;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .am-tabs-default-bar-tab,
  .detail-tab {
    z-index: 1;
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    vertical-align: middle;
    width: auto !important;
    height: 54px;
    padding: 9px 9px 9px 0;
    cursor: pointer;
    border-radius: 50px;
    overflow: hidden;
    .tab-item {
      z-index: 1;
      position: relative;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      vertical-align: middle;
      width: auto;
      height: 34px;
      line-height: 3.4rem;
      padding: 0 14px;
      border-radius: 50px;
      overflow: hidden;
      &::before {
        content: '';
        z-index: -1;
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: inherit;
        opacity: .5;
        border-radius: 50px;
      }
      .txt {
        margin-right: 9px;
        color: ${props.theme.color.themeTxt};
        font-weight: ${props.theme.fontW.medium};
        opacity: .8;
        .favorite-btn-active-img {
          width: 12px;
          height: auto;
          opacity: 0;
          position: absolute;
          top: 10.5px;
          left: 12.5px;
        }
        &.favorite {
          width: 22px;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          margin-left: -6px;
        }
        &.right {
          margin: 0 0 0 9px;
          transform: translateY(1px);
        }
      }
      .num {
        display: inline-block;
        min-width: 21px;
        color: ${props.theme.color.themeTxt};
        opacity: .8;
        text-align: right;
      }
      .profile-img {
        width: 24px;
        height: 24px;
        object-fit: cover;
        border-radius: 50%;
        margin-left: -9px;
        overflow: hidden;
        &.default {
          display: block;
        }
        &.active {
          display: none;
        }
      }
    }
    .am-tabs-default-bar-tab-active,
    .ant-checkbox-wrapper-checked {
      .tab-item {
        .txt {
          opacity: 1;
          .favorite-btn-active-img {
            opacity: 1;
          }
          &.favorite {
            svg {
              .fill {
                fill: ${props.theme.color.yellow};
              }
            }
          }
        }
        .num {
          color: ${props.theme.color.underover};
          opacity: 1;
        }
        .profile-img {
          &.default {
            display: none;
          }
          &.active {
            display: block;
          }
        }
      }
    }
    .ant-checkbox:has(.ant-checkbox-input) {
      display: none;
    }
    
    // 찜 탭 연출
    &.favorite-tab {
      .favorite-btn-active-img {
        width: 16px;
        height: auto;
        opacity: 0;
      }
      &::after {
        content: '';
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: inherit;
        border: 1px solid ${props.theme.color.btn};
        opacity: 0;
        border-radius: 50px;
        transition: all .2s;
      }
      .favorite-effect {
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        width: 300%;
        height: 100%;
        background: linear-gradient(100deg, rgba(80, 96, 112, 0), rgba(80, 96, 112, 0.4), rgba(80, 96, 112, 0));
      }
      &.active {
        &::after {
          opacity: .8;
        }
        .favorite-btn-active-img {
          opacity: 1;
        }
        .favorite-effect {
          opacity: 1;
          animation: ${favoriteTabAni} 1.7s 1 cubic-bezier(.02, .45, .45, .94) forwards;
        }
      }
    }
  }
  .am-tabs-default-bar-tab .tab-item::before {
    border: 1px solid ${props.theme.color.btn};
  }
  .am-tabs-default-bar-tab-active .tab-item::before {
    background-color: ${props.theme.color.btn};
    opacity: 0.3;
    border: none;
  }
  .detail-tab {
    width: 100% !important;
    height: 46px;
    padding: 0 14px;
    background-color: rgba(42, 50, 62, 0.4);
    border-radius: 0;
    cursor: default;
    .ant-checkbox-wrapper {
      height: 100%;
      > span:nth-of-type(2) {
        display: inline-block;
        height: 100%;
        padding: 0 6px;
      }
      + .ant-checkbox-wrapper {
        margin-left: 10px;
      }
      &.ant-checkbox-checked {
        .txt, .num {
          color: ${props.theme.color.themeTxt} !important;
        }
      }
      &.ant-checkbox-wrapper-disabled {
        .txt, .num {
          color: rgba(111, 119, 126, 0.5) !important;
        }
      }
    }
    .tab-item {
      height: 100%;
      padding: 14px 0;
      .txt,
      .num {
        display: inline-flex;
        height: 100%;
        align-items: center;
        justify-content: center;
        color: ${props.theme.color.modalSubBg} !important;
      }
      .txt {
        margin-right: 10px;
      }
      .num {
        min-width: 0;
      }
      .check-icon {
        width: 16px;
        height: 16px;
        margin-right: 6px;
      }
    }
  }
  .am-tabs-default-bar-underline {
    display: none;
  }
  &.num-tab {
    .am-tabs-default-bar-tab {
      .tab-item {
        .num {
          display: block;
        }
      }
    }
  }
  &.home-tab { // 홈에 출력되는 필터탭 (프리미엄 분석가 필터탭 / 나도승부사 필터탭)
    .am-tabs-default-bar-content {
      padding: 0 18px;
    }
  }
`
const underlineTabStyle = (props: TabProps) => css`
  &::before {
    content: '';
    opacity: .2;
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background: ${props.theme.color.btn};
  }
  .am-tabs {
    align-items: center;
  }
  .am-tabs-tab-bar-wrap {
    width: 100%;
  }
  .am-tabs-default-bar {
    width: calc(100% - 14px);
  }
  .am-tabs-default-bar-tab {
    flex: 1;
    width: auto !important;
    height: 40px;
    padding: 8px 0;
    cursor: pointer;
    .tab-item {
      position: relative;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      vertical-align: middle;
      transition: all .3s;
      overflow: visible;
      .txt {
        color: ${props.theme.color.disableTxt};
        font-size: ${props.theme.font.medium};
        position: relative;
        white-space: nowrap;
        .favorite-btn-active-img {
          width: 12px;
          height: auto;
          opacity: 0;
          position: absolute;
          top: 4.5px;
          left: 4.5px;
        }
        &.favorite {
          width: 22px;
          display: inline-flex;
          align-items: center;
          margin-right: 4px;
          svg {
            transform: translateY(-1px);
          }
        }
      }
      .num {
        margin-left: 9px;
        color: ${props.theme.color.disableTxt};
      }
      &.large-txt {
        .txt, .num {
          font-size: ${props.theme.font.large};
        }
      }
      &.sports {
        width: 100%;
        text-align: center;
        border-radius: 10px;
        transition: none;
        padding: 0 6px;
        &.ice-hockey {
          min-width: 60px;
          white-space: nowrap;
        }
      }
    }
  }
  .am-tabs-default-bar-tab-active {
    position: relative;
    &::before {
      content: '';
      display: block;
      position: absolute;
      bottom: 1px;
      left: 50%;
      transform: translateX(-50%);
      width: calc(100% - 32px);
      height: 2px;
      background: ${props.theme.color.underover};
    }
    .tab-item {
      .txt {
        color: ${props.theme.color.themeTxt};
      }
      .num {
        color: ${props.theme.color.underover};
      }
      &.favorite-tab {
        .favorite-btn-active-img {
          opacity: 1;
        }
        svg {
          color: ${props.theme.color.yellow};
          .fill {
              //fill: ${props.theme.color.yellow};
            fill: transparent;
          }
        }
      }
    }
  }
  .am-tabs-default-bar-underline {
    display: none;
  }
  &.match-child-tab {
    z-index: 3;
    position: sticky;
    top: ${stickyMatchTabTop}; /* header 높이 보다 -1한 값 */
    width: 100%;
    .am-tabs-default-bar-tab {
      width: auto !important;
      flex: 1;
    }
    &.fixed-tab {
      position: fixed;
    }
  }
  &.black-line {
    .am-tabs {
      background: ${props.theme.color.modalBg};
      &::before {
        border-bottom: 1px solid ${props.theme.color.gray};
      }
    }
    .am-tabs-default-bar-tab {
      span {
        font-size: ${props.theme.font.large};
      }
    }
    .am-tabs-default-bar-tab-active {
      .tab-item {
        color: ${props.theme.color.mainBg};
      }
      &::before {
        border: 1px solid ${props.theme.color.mainBg};
      }
    }
  }
  &.white-num {
    .am-tabs-default-bar-tab {
      .tab-item {
        min-width: 52px;
      }
      &-active {
        .tab-item {
          .txt {
            color: ${props.theme.color.modalSubBg2};
          }
          .num {
            color: ${props.theme.color.themeTxt};
          }
        }
      }
    }
  }
  // 친구초대 탭
  &.friends-tab {
    background: #fff;
    .am-tabs {
      background: none;
      &::before {
        border-color: #F0F1F5;
      }
    }
    .am-tabs-default-bar-tab {
      display: flex;
      flex-flow: column;
      justify-content: center;
      align-items: center;
      height: 63px;
      line-height: 18px;
      .txt {
        color: #C2C5D1;
        font-size: ${props.theme.font.largeNum};
      }
      .num {
        color: #D7D8E0;
        font-weight: ${props.theme.fontW.medium};
      }
    }
    .am-tabs-default-bar-tab-active {
      &::before {
        background: #596EFF;
      }
      .txt {
        color: #000;
      }
      .num {
        color: #9BA1C2;
      }
    }
  }
  &.no-flex {
    .am-tabs-default-bar-tab {
      flex: initial;
      padding: 8px 14px;
    }
  }
  &.league-tab {
    height: ${matchLeagueTabH};
  }
`
const whiteUnderlineTabStyle = (props: TabProps) => css`
  background: ${props.theme.color.modalBg};
  &::before {
    opacity: 1;
    background: ${props.theme.color.modalSubBg};
  }
  .am-tabs-default-bar-tab {
    .tab-item {
      .txt {
        color: ${props.theme.color.gray};
      }
      .num {
        color: ${props.theme.color.gray};
      }
    }
  }
  .am-tabs-default-bar-tab-active {
    &::before {
      height: 3px;
      background: ${props.theme.color.modalTxt};
    }
    .tab-item {
      .txt {
        color: ${props.theme.color.modalTxt};
      }
      .num {
        color: ${props.theme.color.modalTxt};
      }
    }
  }
  &.left-align {
    .am-tabs-default-bar-content {
      width: auto;
      .am-tabs-default-bar-tab {
        flex: none;
        padding: 8px 14px;
      }
    }
  }
`
const boxTabH = '89px'
const boxTabPaddingTop = '10px'
const boxTabPaddingBottom = '6px'
const boxTabStyle = (props: TabProps) => css`
  .am-tabs-default-bar-content {
    padding: ${boxTabPaddingTop} 14px ${boxTabPaddingBottom};
    overflow-x: auto;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .am-tabs-default-bar-tab {
    z-index: 1;
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    vertical-align: middle;
    width: auto !important;
    height: ${sportTabH};
    padding: 9px 9px 9px 0;
    cursor: pointer;
    overflow: hidden;
    border-radius: 0;
    .tab-item {
      z-index: 1;
      position: relative;
      display: flex;
      flex-flow: column;
      justify-content: flex-start;
      align-items: center;
      vertical-align: middle;
      width: auto;
      min-width: 64px;
      height: calc(${boxTabH} - (${boxTabPaddingTop} + ${boxTabPaddingBottom}));
      line-height: initial;
      padding: 12px 6px 0;
      border-radius: 0;
      overflow: hidden;
      &::before {
        content: '';
        z-index: -1;
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: 100%;
        border: 1px solid ${props.theme.color.btn};
        opacity: .5;
        border-radius: 14px;
      }
      .txt {
        color: ${props.theme.color.disableTxt2};
        font-weight: ${props.theme.fontW.medium};
      }
      .num {
        display: inline-block;
        color: ${props.theme.color.disableTxt2};
        text-align: center;
      }
    }
    &-active {
      .tab-item {
        &::before {
          background: ${props.theme.color.btn} !important;
          opacity: .3;
          border: none;
        }
        .sports-ico {
          .active-ico {
            display: block;
          }
          .default-ico {
            display: none;
          }
        }
        .txt {
          color: ${props.theme.color.themeTxt};
        }
        .num {
          color: ${props.theme.color.underover};
          opacity: 1;
        }
        &.hot-tab {
          .txt, .num {
            z-index: 1;
          }
          .num {
            color: #E05555;
          }
        }
      }
    }
  }
  .am-tabs-default-bar-underline {
    display: none;
  }
`
const whiteBoxTabRoundValue = '6px'
const whiteBoxTabStyle = (props: TabProps) => css`
  width: calc(100% - 192px);
  margin: 95px auto 10px;
  .am-tabs-default-bar-content {
    position: relative;
    border-radius: ${whiteBoxTabRoundValue};
    overflow: hidden;
    border: 1px solid ${props.theme.color.modalBg};
  }
  .am-tabs-default-bar-tab {
    height: 33px;
    cursor: pointer;
    background: rgba(221, 221, 221, .15);
    span {
      color: ${props.theme.color.modalBg};
      font-size: ${props.theme.font.large};
      transition: all 0.3s;
    }
  }
  .am-tabs-default-bar-tab-active {
    background: ${props.theme.color.modalBg};
    span {
      color: ${props.theme.color.modalTxt};
    }
    .special-txt svg {
      opacity: 1;
    }
  }
  .am-tabs-default-bar-underline {
    display: none;
  }
  &.disabled {
    opacity: .3;
    .am-tabs {
      z-index: 0;
    }
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: calc(100% + 50px);
      height: 35px;
      background: red;
      opacity: 0;
    }
  }
  // 베팅 내역 탭
  &.betting-history-tab {
    .am-tabs, .am-tabs-default-bar-content {
      overflow: visible;
    }
    .am-tabs-default-bar-tab {
      width: calc(100% / 2) !important;
      &:nth-of-type(1) {
        border-radius: calc(${whiteBoxTabRoundValue} - 1px) 0 0 calc(${whiteBoxTabRoundValue} - 1px); /* 테두리 라운드값 -1px, 동일한 값으로 적용 시 빈틈이 생김 */
        border-right: 1px solid ${props.theme.color.modalBg};
      }
      &:nth-of-type(2) {
        border-radius: 0;
        border-right: 1px solid ${props.theme.color.modalBg};
      }
      &:nth-of-type(3) {
        width: 0 !important;
      }
      .keep-btn {
        right: -83px;
      }
      &.am-tabs-default-bar-tab-active {
        // 베팅 내역 보관 탭 설정
        .keep-btn {
          .keep-btn-bg {
            background: ${props.theme.color.underover};
          }
        }
      }
    }
    &.betting-share {
      width: calc(100% - 140px);
      .am-tabs-default-bar-tab {
        width: calc(100% / ${props.tabCount}) !important;
        &:nth-of-type(1) {
          border-radius: calc(${whiteBoxTabRoundValue} - 1px) 0 0 calc(${whiteBoxTabRoundValue} - 1px); /* 테두리 라운드값 -1px, 동일한 값으로 적용 시 빈틈이 생김 */
          border-right: 1px solid ${props.theme.color.modalBg};
        }
        &:nth-of-type(2) {
          border-radius: 0;
          border-right: 1px solid ${props.theme.color.modalBg};
        }
        &:nth-of-type(3) {
          border-radius: 0 calc(${whiteBoxTabRoundValue} - 1px) calc(${whiteBoxTabRoundValue} - 1px) 0; /* 테두리 라운드값 -1px, 동일한 값으로 적용 시 빈틈이 생김 */
        }
        &:nth-of-type(4) {
          width: 0 !important;
        }
        .keep-btn {
          right: -50px;
        }
        &.am-tabs-default-bar-tab-active {
          // 베팅 내역 보관 탭 설정
          .keep-btn {
            .keep-btn-bg {
              background: ${props.theme.color.underover};
            }
          }
        }
      }
    }
    // 나도 승부사 작성 시 탭이 진행중/마감 2개밖에 나오지 않음
    &.user-pick {
      .am-tabs-default-bar-tab {
        &:nth-of-type(2) {
          border: none;
          border-radius: 0 calc(${whiteBoxTabRoundValue} - 1px) calc(${whiteBoxTabRoundValue} - 1px) 0; /* 테두리 라운드값 -1px, 동일한 값으로 적용 시 빈틈이 생김 */
        }
      }
    }
  }
`
const fixedTabStyle = (props: TabProps) => css`
  z-index: 3;
  position: sticky;
  top: ${(props.fixed && props.noHeader) ? 0 :
      (props.childFixed && props.noHeader) ? '39px' :
          props.fixed ? stickyMatchTabTop :
              props.childFixed ? `calc(${stickyMatchChildTabTop} - 1px)` : null
  };
  background: ${props.theme.color.mainBg};
  &.fixed-tab {
    position: fixed;
    ${(props.childFixed) && `
      & + * {
        margin-top: calc(${sportTabH} + ${matchLeagueTabH} - 1px);
      }
      &.user-pick-tab + * {
        margin-top: 99px;
      }
    `}
  }
`
const roundTabNoNumStyle = (props: TabProps) => css`
  .am-tabs-default-bar-tab {
    .tab-item {
      .txt {
        margin-right: 0;
      }
      .num {
        display: none;
      }
    }
  }
  .am-tabs-default-bar-tab-active {
    .txt {
      color: ${props.theme.color.underover};
    }
  }
`
const underlineTabNoNumStyle = css`
  .am-tabs-default-bar-tab {
    .tab-item {
      justify-content: center;
      .txt {
        margin-right: 0;
      }
      .num {
        display: none;
      }
    }
  }
`
const leftAlignTabStyle = css`
  .am-tabs .am-tabs-tab-bar-wrap .am-tabs-default-bar {
    padding: 0 14px;
    .am-tabs-default-bar-content {
      width: auto;
      .am-tabs-default-bar-tab {
        padding: 0 12px;
        &::before {
          width: 100%;
        }
      }
    }
  }
`
const hotTabAni = keyframes`
  0% {
    filter: url(#glow);
  }
  50% {
    filter: none;
  }
  100% {
    filter: url(#glow);
  }
`
const IconTabStyle = css`
  .sports-ico {
    display: block;
    min-width: 18px;
    min-height: 18px;
    margin-right: 0;
    margin-bottom: 2px;
    &.all-ico {
      min-width: 32px;
    }
    &.hot-ico {
      min-width: 36px;
      .active-ico, .default-ico {
        width: auto;
        height: 100%;
        > img {
          position: absolute;
          width: 64px;
          height: 73px;
          top: calc(50% + 16px);
          left: 50%;
          transform: translate(-50%, -50%);
        }
        > svg {
          width: 36px;
          height: 100%;
          top: calc(50% + -0.5px);
          path {
            fill: #798897;
          }
        }
      }
      .active-ico {
        path {
          animation: ${hotTabAni} 2s ease-in-out infinite;
        }
      }
    }
    .active-ico, .default-ico {
      width: auto;
      height: 100%;
    }
    .active-ico {
      display: none;
    }
    .default-ico {
      display: block;
    }
  }
`
const tabSlideAni = keyframes`
  0% {
    opacity: 0;
    transform: translateX(50px);
  }
  60% {
    opacity: 1;
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
`
const tabAniDelay = '0.02s'
export const TotalTabWrap = styled.div<TabProps>`
  position: relative;
  width: 100%;
  max-width: 100vw;
  height: auto;
  &.bettor-find-tabs {
    background: ${props => props.theme.color.themeTxt};
    margin-bottom: -2px;
    .am-tabs-default-bar {
      width: calc(100% - 43px);
      overflow: auto hidden;
      &::-webkit-scrollbar {
        display: none;
      }
    }
    .am-tabs-default-bar-content {
      padding-left: 4px;
    }
    .am-tabs-default-bar-tab,
    .am-tabs-default-bar-tab-active {
      padding: 10px 12px !important;
    }
    .am-tabs-default-bar-tab:has(.bettor-find-all) {
      display: none;
    }
  }
  .sports-ico {
    display: none;
  }
  ${props => {
    if (props.round) return roundTabStyle
    if (props.underline || props.whiteUnderline) return underlineTabStyle
    if (props.box) return boxTabStyle
    if (props.whiteBox) return whiteBoxTabStyle
    return
  }};
  ${props => {
    if (props.round && props.noNum) return roundTabNoNumStyle
    if (props.underline && props.noNum) return underlineTabNoNumStyle
    if (props.whiteUnderline) return whiteUnderlineTabStyle
    return
  }};
  ${props => {
    if (props.leftAlign) return leftAlignTabStyle
    return
  }};
  ${props => {
    if (props.fixed || props.childFixed) return fixedTabStyle
    return
  }};
  ${props => {
    if (props.iconTab) return IconTabStyle
    return
  }};
  .am-tabs-default-bar-content {
    transform: none !important;
    touch-action: pan-x !important;
  }
  &.sport-tab {
    .am-tabs-default-bar-tab {
      height: auto;
      padding: 0 9px 0 0;
    }
    .hide-tab {
      visibility: hidden;
    }
    .sport-tab-ani {
      visibility: visible;
      .am-tabs-default-bar-content {
        .am-tabs-default-bar-tab {
          opacity: 0;
          animation: ${tabSlideAni} 1 .35s forwards cubic-bezier(.52, .03, .51, .99);

          &:nth-of-type(2) {
            animation-delay: ${tabAniDelay};
          }

          &:nth-of-type(3) {
            animation-delay: calc(${tabAniDelay} * 2);
          }

          &:nth-of-type(4) {
            animation-delay: calc(${tabAniDelay} * 3);
          }

          &:nth-of-type(5) {
            animation-delay: calc(${tabAniDelay} * 4);
          }

          &:nth-of-type(6) {
            animation-delay: calc(${tabAniDelay} * 5);
          }

          &:nth-of-type(7) {
            animation-delay: calc(${tabAniDelay} * 6);
          }
        }
      }
    }
  }
  // 탭 우측에 필터 버튼이 들어가는 경우
  &.league-tab {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .am-tabs {
      flex: initial;
    }
  }
  &.show-scroll {
    .am-tabs-default-bar {
      overflow-x: auto;
      overflow-y: hidden;
      &::-webkit-scrollbar {
        display: block !important; /* 팝업내 스크롤바 보이도록 */
      }
      .am-tabs-default-bar-content {
        overflow: initial;
      }
    }
    &:not:has(.filter-button-wrap) {
      &.league-tab
      .am-tabs-default-bar {
        width: calc(100% - 39px);
      }
    }
    &.league-tab
      .am-tabs-default-bar {
        white-space: nowrap;
      }
    }
  }
  .match-up-result {
    position: absolute;
    right: 0;
    background: #1C202B;
    z-index: 1;
  }
  // 탭 숫자 고정너비가 유동너비
  &.auto-width {
    .am-tabs-default-bar-tab {

      .tab-item {
        .num {
          min-width: auto;
        }
      }
    }
  }
  .filter-button-wrap {
    margin-right: 14px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .league-filter-button {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 80px;
    height: 30px;
    border-radius: 8px;
    border: 1px solid transparent;
    background-image: linear-gradient(#1c202b, #1c202b), linear-gradient(-30deg, #47FFF3 0%, #9EFF74 100%);
    background-origin: border-box;
    background-clip: content-box, border-box;
    font-family: "Roboto", "Noto", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
    font-weight: ${props => props.theme.fontW.bold};
    font-size: ${props => props.theme.font.medium};
    color: ${props => props.theme.color.themeTxt};
    .league-filter-button-content {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 4px;
      padding: 0 10px;
    }
    .league-filter-icon {
      width: 17px;
      height: 20px;
    }
  }
`

export const RoundTabWrap = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  &::before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: ${RoundTabHeight};
    background: ${props => props.theme.color.mainBg};
  }
  .round-tab-wrap {
    z-index: 1;
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    vertical-align: middle;
    width: auto;
    height: 34px;
    line-height: 3.4rem;
    padding: 0 14px;
    border-radius: 50px;
    overflow: hidden;
    &::before {
      content: '';
      z-index: -1;
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      height: inherit;
      border: 1px solid ${props => props.theme.color.btn};
      opacity: .5;
      border-radius: 50px;
    }
    .txt {
      margin-right: 12px;
      color: ${props => props.theme.color.themeTxt};
      font-weight: ${props => props.theme.fontW.medium};
      opacity: .8;
      &.favorite {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        margin-left: -6px;
      }
    }
    .num {
      min-width: 21px;
      color: ${props => props.theme.color.themeTxt};
      opacity: .8;
      text-align: right;
    }
    // 찜 탭 연출
    &.favorite-tab {
      &::after {
        content: '';
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: inherit;
        border: 1px solid ${props => props.theme.color.btn};
        opacity: 0;
        border-radius: 50px;
        transition: all .2s;
      }
      .favorite-effect {
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        width: 300%;
        height: 100%;
        background: linear-gradient(100deg, rgba(80, 96, 112, 0), rgba(80, 96, 112, 0.4), rgba(80, 96, 112, 0));
      }
      &.active {
        &::after {
          opacity: .8;
        }
        .favorite-effect {
          opacity: 1;
          animation: ${favoriteTabAni} 1.7s 1 cubic-bezier(.02, .45, .45, .94) forwards;
        }
      }
    }
  }
  &.filter {
    ${StickyChildTab};
    top: 74px;
    height: ${RoundTabHeight};
    padding-right: 14px;
    overflow: auto;
    background: ${props => props.theme.color.mainBg};
    &::before {
      display: none;
    }
    &.pc-filter {
      position: relative;
      top: initial;
    }
  }
  .am-tabs-top,
  .am-tabs-bottom {
    width: 100%;
  }
  .am-tabs-default-bar-content {
    padding: 0 14px;
  }
  .am-tabs .am-tabs-tab-bar-wrap .am-tabs-default-bar {
    background: ${props => props.theme.color.mainBg} !important;
    overflow-y: hidden;
    overflow-x: scroll !important;
  }
  .am-tabs .am-tabs-tab-bar-wrap .am-tabs-default-bar::-webkit-scrollbar {
    display: none !important;
  }
  .am-tabs-default-bar-top .am-tabs-default-bar-content,
  .am-tabs-default-bar-bottom .am-tabs-default-bar-content {
    height: ${RoundTabHeight};
    transform: none !important;
    touch-action: auto !important;
  }
  .am-tabs-default-bar-tab {
    position: relative;
    width: auto !important;
    height: ${RoundTabHeight};
    padding-right: 9px;
    cursor: pointer;
    // IOS 26 WebKit 우회처리 — 각 탭을 독립 합성 레이어로 강제 분리
    // 0010752: [모바일웹] 아이폰 단말에서 상세 BET 하위 탭 클릭 시 선택 상태가 중복으로 유지되는 현상
    // (https://task.zempublic.co.kr/view.php?id=10752)
    will-change: transform;  
    &:nth-last-of-type(2) {
      padding-right: 30px;
    }
  }
  .am-tabs-default-bar-underline {
    display: none;
  }
  .am-tabs-default-bar-top .am-tabs-default-bar-nextpage,
  .am-tabs-default-bar-bottom .am-tabs-default-bar-nextpage,
  .am-tabs-default-bar-top .am-tabs-default-bar-prevpage,
  .am-tabs-default-bar-bottom .am-tabs-default-bar-prevpage {
    display: none;
  }
  .am-tabs-default-bar-tab-active {
    .round-tab-wrap {
      &::before {
        background: ${props => props.theme.color.btn};
        opacity: .3;
        border: none;
      }
      .txt {
        opacity: 1;
        &.favorite {
          svg .fill {
            fill: ${props => props.theme.color.yellow};
          }
        }
      }
      .num {
        color: ${props => props.theme.color.underover};
        opacity: 1;
      }
    }
  }
  .am-tabs-default-bar-tab p.Disabled span {
    color: ${props => props.theme.color.disableTxt};
    opacity: 0.5;
  }

  &.matchup-detail {
    position: sticky;
    top: -1px;
    z-index: 1;
    background: ${props => props.theme.color.mainBg};
    overflow: hidden;
    .am-tabs-default-bar-content, .am-tabs-default-bar-tab {
      height: 60px;
    }
    &.show-simple-info {
      animation: ${betDetailTabAni} .15s 1 forwards cubic-bezier(.02, .67, .48, 1);
    }
    &.live-score-tab.betradar {
      animation: ${betDetailBetradarLiveTabAni} .15s 1 forwards cubic-bezier(.02, .67, .48, 1);
    }
    &.live-score-tab.statscore {
      animation: ${betDetailStatScoreLiveTabAni} .15s 1 forwards cubic-bezier(.02, .67, .48, 1);
    }
    .num {
      min-width: auto;
    }
  }

`
export const FilterBtnStyle = (theme: Theme) => css`
  position: absolute;
  top: 5px;
  right: -30px;
  width: 27px;
  height: 26px;
  padding: 0;
  background: ${theme.color.btn};
  border: none;
  border-radius: 13px 0 0 13px;
  svg {
    position: relative;
    top: 3px;
    width: 14px;
  }
  &::before {
    display: none;
  }
`
// 매치업 / 매치업 결과 / 메시지함에 쓰이고 있음
export const Content = styled.div`
  background: ${props => props.theme.color.TP};
  &.match-list {
    flex-wrap: wrap;
    margin-bottom: 57px;
    padding-bottom: ${NavBottomPadding};
    &.pc, &.matchupFilter, &.matchupResultFilter {
      margin-bottom: 0;
      padding-bottom: 0;
    }
    &.matchupFilter, &.matchupResultFilter {
      .am-list {
        min-height: calc(100vh - 187px);
        margin-bottom: 57px;
        padding-bottom: ${NavBottomPadding};
      }
    }
    .am-list {
      width: 100%;
    }
    > .am-list {
      margin-top: 9px;
    }
  }
`
export const TabTxt = styled.span`
  position: relative;
  font-size: ${props => props.theme.font.medium};
  line-height: 1.2rem;
  transition: all 0.3s;
  overflow: visible;
  &.sports {
    width: 100%;
    height: 26px;
    line-height: 2.6rem;
    text-align: center;
    border-radius: 10px;
    transition: none !important;
    padding: 0 6px;
  }
  &.ice-hockey {
    min-width: 60px;
    white-space: nowrap;
  }
  &.special-txt {
    text-indent: 10px;
    svg {
      position: absolute;
      top: 50%;
      left: -5px;
      transform: translate(0, -52%);
      width: 12px;
      opacity: .5;
    }
  }
  &.live-txt {
    float: left;
  }
  &.filter {
    ${TxtLimit3};
    margin-right: 12px;
    width: auto;
    max-width: 80%;
    font-size: ${props => props.theme.font.medium} !important;
    &.today-league-txt {
      min-width: 45px;
      margin: 0 12px 0 4px;
    }
    /* 상세 경기 탭 */
    &.detail {
      margin: 0;
      text-align: left;
    }
  }
  /* 이벤트 팝업 tab */
  &.event-text {
    font-size: ${props => props.theme.font.small} !important;
  }
  /* 채팅 팝업 tab */
  &.modal {
      /* color: ${props => props.theme.color.modalTxt}; */
  }
  &.item-shop {
    margin: 0 3px;
    line-height: 2rem;
    svg {
      width: 14px;
      margin-right: 3px;
      transform: translateY(18%);
    }
  }
  &.favorite {
    width: 18px;
    height: 18px;
    svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -51%);
      width: inherit;
      .txt {
        fill: ${props => props.theme.color.themeTxt};
      }
      .txt-line {
        fill: ${props => props.theme.color.matchTit2};
      }
    }
  }
  &.white-tab-txt {
    min-width: 36px;
    text-align: center;
    svg, img {
      width: 21px;
    }
    &.select-live-tab-all {
      color: ${props => props.theme.color.themeTxt};
      font-size: ${props => props.theme.font.small};
    }
    &.dia-tab-txt {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      min-width: 52px;
      svg {
        width: auto;
        height: 12px;
        min-height: 12px;
        margin-right: 3px;
      }
    }
    &.column {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      flex-flow: column;
      svg {
        margin-bottom: 2px;
      }
    }
  }
  &.flex-type {
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    .txt {
      width: 60px;
    }
    .num {
      width: auto;
      margin-left: 12px;
    }
  }
`
export const BetCouponTag = styled.span`
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(0, -50%);
  display: flex;
  justify-content: space-around;
  width: 100%;
  height: 28px;
  line-height: 2.8rem;
  padding: 0 8px;
  align-items: center;
  text-align: center;
  border-radius: 50px;
  color: ${props => props.theme.color.modalSubBg2};
  background: #4C3030;
  svg {
    width: 9px;
  }
`

// /////////////////////////////////////////// full modal /////////////////////////////////////////////
// scroll 가능한 팝업에서 묶어주기
export const ModalContents = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: scroll;
  border-top: 1px solid ${props => props.theme.color.modalBg};
  /* 픽 공유 모달 */
  &.bottom-space {
    padding-bottom: 40px;
  }
  .am-list-body {
    background: none;
  }
`
// /////////////////////////////////////////// 수량 버튼(+/-) /////////////////////////////////////////////
export const NumInputGroup = styled.div`
  width: 100%;
  height: 28px;
  line-height: 2.8rem;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  background: ${props => props.theme.color.btn};
  border-radius: 50px;
  .btn {
    width: 30px;
    height: inherit;
    padding: 0;
    line-height: inherit;
    background: ${props => props.theme.color.btn};
    border: none;
    font-size: 2rem;
    font-weight: 400 !important;
  }
  .left.btn {
    font-size: 2.6rem;
    border-radius: 50px 0 0 50px;
  }
  .right.btn {
    border-radius: 0 50px 50px 0;
  }
  .input {
    width: calc(100% - 60px);
    height: inherit;
    text-align: center;
    line-height: 2.8rem;
    color: ${props => props.theme.color.themeTxt} !important;
    border: none;
    border-radius: 0;
    &:hover {
      box-shadow: none !important;
    }
  }
  .number-format {
    background-color: transparent;
  }
  &.modal {
    position: relative;
    top: 2px;
    height: 35px;
    line-height: 3.5rem;
    background: ${props => props.theme.color.modalSubBg};
    .btn {
      line-height: inherit;
      color: ${props => props.theme.color.modalSubTxt};
      background: ${props => props.theme.color.modalSubBg};
    }
    .input {
      line-height: inherit;
      color: ${props => props.theme.color.modalTxt} !important;
      font-size: ${props => props.theme.font.large};
    }
  }
  /* 아이템 선물하기 */
  &.my-item {
    z-index: 1;
    position: absolute;
    top: 69px;
    left: 50%;
    width: calc(100% - 24px);
    height: 28px;
    line-height: 2.8rem;
    transform: translate(-50%, 0);
  }
  // 아이템샵
  &.white-input {
    background: ${props => props.theme.color.modalSubBg};
    .btn {
      color: ${props => props.theme.color.btn};
      background: ${props => props.theme.color.modalSubBg};
    }
    .input {
      color: ${props => props.theme.color.mainBg} !important;
    }
  }
`
// /////////////////////////////////////////// Modal  /////////////////////////////////////////////

export const ModalStyle = css`
  /* top: 25% !important; */
  .ant-modal-body {
    padding: 40px 24px 12px;
  }
  .ant-modal-close {
    display: none;
  }
`
export const JoinClubModalStyle = css`
  z-index: 99999;
  top: 35% !important;
  .ant-modal-body {
    padding: 40px 24px 12px;
  }
  .ant-modal-close {
    display: none;
  }
`
export const PickModalStyle = css`
  top: 25% !important;
  .ant-modal-body {
    padding: 40px 24px 12px;
  }
  .ant-modal-close {
    display: none;
  }
`
export const PickCompleteModalStyle = css`
  top: 32% !important;
  .ant-modal-body {
    padding: 40px 24px 12px;
  }
  .ant-modal-close {
    display: none;
  }
`
// 모달 뒷배경
export const ModalBg = styled.div`
  z-index: -1;
  position: fixed;
  top: 50%;
  left: 50%;
  width: 100vw;
  height: 500vh;
  background-color: rgba(0, 0, 0, 0.8);
  transform: translate(-50%, -50%);
  &.clickable {
    z-index: 0;
  }
  &.none {
    background: transparent;
  }
  &.gift-box {
    opacity: .85; /* 서랍메뉴 내에서 열리기 때문에 투명도 조절 필요 */
  }
`

export const ModalTxt = styled.p`
  margin: 5px 0 20px;
  line-height: 2.4rem;
  font-size: ${props => props.theme.font.title};
  color: ${props => props.theme.color.modalTxt};
`
// /////////////////////////////////////////// iframe /////////////////////////////////////////////
const iframeWrapAni = keyframes`
  0%, 50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`
// betradar 관련 ani
const iframeBetradarAni = keyframes`
  0% {
    height: 0;
  }
  100% {
    height: 76vmin;
  }
`
const iframeLiveBetradarAni = keyframes`
  0% {
    height: 0;
  }
  100% {
    height: 94vmin;
  }
`
const iframeLiveScoreBetradarAni = keyframes`
  0% {
    height: 0;
  }
  100% {
    height: ${liveDetailBetradarH};
  }
`

// statscore 관련 ani
const iframeStatscoreAni = keyframes`
  0% {
    height: 0;
  }
  100% {
    height: 90vmin;
  }
`
const iframeLiveStatscoreAni = keyframes`
  0% {
    height: 0;
  }
  100% {
    height: 88.6vmin;
  }
`
const iframeLiveScoreStatscoreAni = keyframes`
  0% {
    height: 0;
  }
  100% {
    height: ${liveDetailStatScoreH};
  }
`

const iframeLiveScoreWrapClsAni = keyframes`
  0% {
    height: ${liveDetailStatScoreH};
  }
  100% {
    height: 0;
  }
`
export const HomeTagCommonStyle = (props: ThemeProps) => css`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 16px;
  height: 16px;
  background: ${props.theme.color.themeTxt};
  border: 1px solid ${props.theme.color.subBg};
  border-radius: 50%;
  &::after {
    content: '홈';
    display: block;
    color: ${props.theme.color.mainBg};
    font-size: ${props.theme.font.small};
  }
`
// Visualization iframe (상세 경기 모달)
const visualizationSidePadding = '21px'
export const IframeWrap = styled.span`
  display: block;
  width: 100%;
  height: auto;
  padding: 4px ${visualizationSidePadding} 0;
  background: ${props => props.theme.color.mainBg};
  overflow: hidden;
  // 상세 BET 비주얼라이제이션
  &.detail-bet-iframe {
    opacity: 0;
    animation: ${iframeWrapAni} .3s .85s 1 forwards ease-in;
    .home-tag-img {
      position: absolute;
      width: 20px;
      height: auto;
    }
    iframe {
      width: 100%;
      height: 0;
      max-height: 661px;
      ${mqMinPortrait[2]} {
        max-height: 626px;
      }
      ${mqMinPortrait[3]} {
        max-height: 661px;
      }
    }
    &.pc {
      opacity: 1;
      animation: none;
    }
    // betradar iframe
    &.betradar {
      padding: 4px 14px 0;
      .home-tag-img {
        top: 9px;
        left: 16px;
        &.baseball {
          right: 16px;
          left: unset;
        }
        &.table-tennis {
          top: 10px;
          left: 10px;
        }
      }
      iframe {
        animation: ${iframeBetradarAni} .3s .8s 1 forwards cubic-bezier(.81, .15, 0, 1);
      }
      &.pc {
        iframe {
          height: 375px;
          max-height: 375px;
          animation: none;
        }
      }
      &.live-extended {
        iframe {
          animation: ${iframeLiveBetradarAni} .3s .8s 1 forwards cubic-bezier(.81, .15, 0, 1);
        }
        &.pc {
          iframe {
            height: 440px;
            max-height: 440px;
            animation: none;
          }
        }
      }
    }
    // statscore iframe
    &.statscore {
      .home-tag-img {
        top: 7px;
        left: 9px;
        &.pc {
          width: 23px;
        }
      }
      iframe {
        animation: ${iframeStatscoreAni} .3s .8s 1 forwards cubic-bezier(.81, .15, 0, 1);
      }
      &.pc {
        iframe {
          height: 450px;
          max-height: 450px;
          animation: none;
        }
      }
      &.live-extended {
        .home-tag-img {
          top: 15px;
        }
        iframe {
          animation: ${iframeLiveStatscoreAni} .3s .8s 1 forwards cubic-bezier(.81, .15, 0, 1);
        }
        &.pc {
          iframe {
            height: 445px;
            max-height: 445px;
            animation: none;
          }
        }
      }
    }
  }
  // sport-talk-popup
  &.sport-talk-popup {
    &.detail-bet-iframe {
      &.betradar {
        &.live-extended {
          &.pc {
            iframe {
              height: 380px;
              max-height: 380px;
            }
          }
        }
      }
    }
  }
  &.modal {
    height: 70vw;
    min-height: 320px;
    padding: 0;
    iframe {
      //min-height: 320px;
      height: 100%;
      animation: none;
    }
    ${mqMinH[2]} {
      height: inherit;
    }
    ${mqMinH[3]} {
      height: inherit;
    }
    ${mqMinH[5]} {
      height: inherit;
    }
    ${mq[1]} {
      height: inherit;
      min-height: 280px;
      iframe {
        min-height: 280px;
      }
    }
    ${mqH[0]} {
      height: inherit;
    }
    /* PC */
    ${mqPC[6]} {
      height: inherit;
      min-height: initial;
      iframe {
        min-height: initial;
      }
    }
  }
`
export const LiveScoreIframeWrap = styled.div`
  animation: ${iframeLiveScoreWrapClsAni} .15s 1 forwards ease-in-out;
  overflow: hidden;
  iframe {
    width: 100%;
  }
  .iframe-home-tag {
    position: absolute;
    top: 4px;
    left: 4px;
    ${HomeTagCommonStyle};
    display: none;
    &.baseball {
      right: 4px;
      left: unset;
    }
  }
  &.show-live-score {
    display: block;
    z-index: 2;
    position: sticky;
    top: -1px;
    height: auto;
    padding: 0 ${visualizationSidePadding};
    background: ${props => props.theme.color.mainBg};
    animation: none;
    .home-tag-img {
      position: absolute;
      width: 20px;
      height: auto;
    }
    &.betradar {
      padding: 0;
      .home-tag-img {
        top: 4px;
        left: 4px;
        &.baseball {
          right: 4px;
          left: unset;
        }
        &.table-tennis {
          top: 5px;
          left: -2px;
        }
      }
      iframe {
        animation: ${iframeLiveScoreBetradarAni} .15s 1 forwards cubic-bezier(.02, .67, .48, 1);
      }
    }
    &.statscore {
      .home-tag-img {
        top: 15px;
        left: 9px;
        &.pc {
          width: 23px;
        }
      }
      iframe {
        animation: ${iframeLiveScoreStatscoreAni} .15s 1 forwards cubic-bezier(.02, .67, .48, 1);
      }
    }
  }
`

// /////////////////////////////////////////// LoadSpin /////////////////////////////////////////////
const ballAni = keyframes`
  from {
    transform: translate3d(0, 30px, 0) scale(1.12, .88);
  }
  to {
    transform: translate3d(0, 0, 0) scale(.98, 1.02);
  }
`
const appearAni = keyframes`
  0% {
    opacity: 1;
    transform: rotate(0);
  }
  28% {
    opacity: 1;
  }
  29% {
    opacity: 0;
  }
  40% {
    transform: rotate(90deg);
  }
  100% {
    opacity: 0;
  }
`
const shadowAni = keyframes`
  from {
    width: 34px;
    height: 12px;
    opacity: .4;
  }
  to {
    width: 18px;
    height: 10px;
    opacity: .2;
  }
`

export const LoadSpinWrap = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
  flex-wrap: nowrap;
  text-align: center;
  height: 35vh;
  .ball-wrapper {
    position: relative;
    width: 40px;
    height: 40px;
    animation: ${ballAni} .5s infinite cubic-bezier(.25, 0, .01, .9) alternate;
    svg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      animation: ${appearAni} 4s ease infinite;
      &:nth-of-type(2) {
        animation-delay: 1s;
      }
      &:nth-of-type(3) {
        animation-delay: 2s;
      }
      &:nth-of-type(4) {
        animation-delay: 3s;
      }
    }
  }
  .shadow {
    width: 36px;
    height: 14px;
    background: #0a0d13;
    opacity: .4;
    border-radius: 50%;
    transform: translate(0, 76px);
    animation: ${shadowAni} .5s infinite cubic-bezier(.25, 0, .01, .9) alternate !important;
  }
`
const bottomLoadingScaleAni = keyframes`
  0% {
    transform: rotate(365deg);
  }
`
export const BottomLoadingWrap = styled.div`
  position: relative;
  width: 100%;
  height: 50px;
  padding: 5px;
  text-align: center;
  .default {
    position: relative;
    width: 25px;
    height: 25px;
    margin: 0 auto;
    &::before, &::after {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: inherit;
      height: inherit;
      border-radius: 50%;
    }
    &::before {
      opacity: .15;
      border: 1px solid ${props => props.theme.color.themeTxt};
      transform: scale(.98);
    }
    &::after {
      border: 2px solid transparent;
      border-top-color: ${props => props.theme.color.primary};
      animation: ${bottomLoadingScaleAni} .9s infinite cubic-bezier(.27, .53, .28, .97);
      animation-delay: .11s;
    }
    &--bar {
      position: relative;
      display: block;
      width: inherit;
      height: inherit;
      border-radius: 50%;
      border: 2px solid transparent;
      border-top-color: ${props => props.theme.color.primary};
      animation: ${bottomLoadingScaleAni} .9s infinite cubic-bezier(.27, .53, .28, .97);
    }
  }
`
export const LoadingStyle = (theme: Theme) => css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: calc(100vh - 130px);
  background: ${theme.color.contentsBg};
`
// 데이터 없을 경우 '-'표시
export const Loaded = styled.div`
  position: relative;
  width: 100%;
  height: 35px;
  display: block;
  margin: 0 auto;
  line-height: 3rem;
  text-align: center;
  background: ${props => props.theme.color.contentsBg};
  transform: translate(-50%, -50%);
  &::before {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 16px;
    border: ${props => props.theme.border.inputLine};
    transform: translate(-50%, -50%);
  }
`

// //////////////////////////////////////// Empty ////////////////////////////////////////
export const EmptyWrap = styled.div`
  height: calc(100vh - 182px);
  /* pc */
  max-height: 537px;
  .empty-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    transform: translate(-50%, -60%);
    &--ico {
      padding: 0 0 20px;
      img {
        width: 135px;
        height: auto;
        &.visualization-empty {
          display: block;
          margin: 0 auto;
        }
      }
    }
    &--txt {
      white-space: pre-line;
      margin: 0 auto;
      text-align: center;
      line-height: 1.8rem;
      color: ${props => props.theme.color.gray};
      font-size: ${props => props.theme.font.large};
    }
  }
  &.adv-empty-bettor-list {
    height: 300px;
  }
  &.adv-empty-match, &.adv-empty-match-live {
    .empty-wrap {
      position: relative;
      top: 50%;
      left: 0;
      transform: translate(0, -80%);
    }
  }
  &.adv-empty-match-detail {
    height: 38vh;
    min-height: 400px;
    &.contents-tab {
      min-height: 660px;
    }
    .empty-wrap {
      position: relative;
    }
  }
  &.adv-empty-match-filter, &.adv-empty-one-fold-club {
    max-height: 350px;
    background: ${props => props.theme.color.modalDarkBg};
    .empty-wrap {
      transform: translate(-50%, -50%);
      &--txt {
        color: ${props => props.theme.color.modalTxt};
      }
    }
  }
  &.adv-empty-change-match {
    max-height: 250px;
    background: ${props => props.theme.color.modalDarkBg};
    .empty-wrap {
      transform: translate(-50%, -50%);
      &--txt {
        color: ${props => props.theme.color.modalTxt};
      }
    }
  }
  &.adv-empty-one-fold-club {
    height: 167px;
    .empty-wrap {
      &--ico {
        padding: 0;
      }
    }
  }
  &.adv-empty-bet-history {
    height: 50vh;
    max-height: 420px;
  }
  &.adv-empty-user-pick-profile {
    max-height: 250px;
    background: none;
    .empty-wrap {
      transform: translate(-50%, -50%);
      &--txt {
        color: ${props => props.theme.color.modalTxt};
      }
    }
  }
`
// ///////////////////////// Badge ////////////////////////////////////
export const BadgeStyle = (theme: Theme) => css`
  position: absolute;
  top: 7px;
  right: -1px;
  .am-badge-text {
    height: 12px;
    line-height: 1.3rem;
    padding: 0 4px;
    font-size: ${theme.font.tiny};
    background: ${theme.color.red};
  }
  // ant badge
  .ant-badge-count {
    box-shadow: none;
    .ant-scroll-number-only {
      display: inline-flex;
      flex-flow: column;
      transition: none;
    }
  }
  .am-badge-dot {
    background: ${theme.color.red};
  }
  &.left-tab-badge {
    float: left;
    position: relative;
    top: 0;
    right: 0;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin-left: 4px;
    .am-badge-text {
      position: relative;
      display: inline-flex;
      justify-content: center;
      //align-items: center;
      top: 0;
      transform: none;
      width: 16px;
      height: 16px;
      line-height: 1.6rem;
      font-size: ${theme.font.small};
      background: none;
      &::before {
        content: '';
        display: block;
        z-index: -1;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -52%);
        width: 100%;
        height: 100%;
        background: ${theme.color.red};
        border-radius: 100px;
      }
    }
    &.inactive {
      .am-badge-text {
        background: ${theme.color.disableTxt};
      }
    }
    &.live-badge {
      margin-left: 3px;
      .am-badge-text {
        min-width: 18px;
        width: 100%;
        height: 18px;
        line-height: 18px;
        font-size: ${theme.font.large};
      }
    }
  }
  &.tab-badge {
    float: left;
    position: relative;
    top: 0;
    right: 0;
    left: 3px;
    .am-badge-text {
      top: 0;
      transform: translateX(0);
    }
    &.inactive {
      .am-badge-text {
        background: ${theme.color.disableTxt};
      }
    }
    &.bet-history-tab {
      .am-badge-text {
        width: auto;
        min-width: 16px;
        height: 16px;
        line-height: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: ${theme.font.medium};
      }
    }
  }
  &.club-info {
    .am-badge-text {
      top: -4px;
      right: -8px;
    }
  }
  &.club-event-badge {
    position: absolute;
    top: -1px;
    right: 2px;
    .am-badge-dot {
      width: 10px;
      height: 10px;
      border: 2px solid ${theme.color.mainBg};
    }
  }
  &.message-badge {
    position: absolute;
    top: 9px;
    right: 4px;
    .am-badge-dot {
      width: 10px;
      height: 10px;
      border: 2px solid ${theme.color.mainBg};
    }
  }
  &.filter-badge {
    position: relative;
    top: -1px;
    right: initial;
    margin-left: 4px;
    background: ${theme.color.select};
    border-radius: 50px;
    .ant-scroll-number.ant-badge-count {
      max-height: 18px;
      transform: translateY(-1px);
      background: ${theme.color.TP};
    }
    &.zero {
      background: ${theme.color.modalDarkBg};
    }
  }
  &.pick-badge {
    top: 3px;
    left: 50%;
    transform: translateX(calc(-50% + 10px));
    .am-badge-text {
      display: inline-block;
      text-align: center;
      transform-origin: center;
      width: auto;
      height: 14px;
      padding: 1px 4px 0 4px;
      background: linear-gradient(135deg, #9EFF74, #72FFF6);
      line-height: ${theme.font.large};
      font-size: ${theme.font.small};
      color: #1B1F2A;
      letter-spacing: -0.4px;
    }
  }
  &.pick-badge-tab {
    opacity: .5;
    top: 6px;
    right: calc(50% - 18px);
    transform: translateX(50%);
    .am-badge-text {
      top: initial;
      transform: initial;
      position: absolute;
      left: 0;
    }
    &.sport-talk {
      right: calc(50% - 25px);
    }
  }
`
export const GoTopIcoStyle = styled.div`
  position: relative;
  width: 45px;
  height: 45px;
  backdrop-filter: blur(20px);
  border-radius: 50%;
  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    height: 20px;
    transform: translate(-50%, -50%);
    opacity: .6;
  }
  &::before {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    width: inherit;
    height: inherit;
    transform: translate(-50%, -50%);
    background: ${props => props.theme.color.btn};
    border-radius: 50%;
    opacity: 0.3;
  }
`
// //////////////////////////////////////// banner ////////////////////////////////////////
export const MatchupBannerWrap = styled.div`
  display: block;
  width: 100%;
  .img {
    width: 100%;
    height: auto;
  }
  &.sports {
    width: auto;
    height: auto;
    margin: 0 4px 4px;
    .banner-btn {
      width: 100%;
      min-height: 151px;
      border-radius: 15px;
      overflow: hidden;
      background: none;
    }
    &.pc {
      .banner-btn {
        border-radius: 0;
      }
    }
  }
`
// 캐릭터가 들어간 팝업 - 캐릭터 영역
export const CharacterImgWrap = styled.div`
  z-index: -1;
  position: absolute;
  top: -145px;
  left: 50%;
  width: 270px;
  max-width: 400px;
  height: 145px;
  transform: translate(-50%, 0);
  .character-img {
    position: absolute;
    width: 99px;
    bottom: 0;
    right: -10px;
  }
  .speech-bubble {
    position: absolute;
    width: 167px;
    height: 133px;
    top: 0;
    left: 0;
    background: ${props => props.theme.color.matchTit1};
    border-radius: 10px;
    &::before {
      content: '';
      display: block;
      position: absolute;
      top: 50%;
      right: -8px;
      width: 0;
      height: 0;
      border-top: 8px solid transparent;
      border-left: 8px solid ${props => props.theme.color.matchTit1};
      border-bottom: 8px solid transparent;
    }
    &--tit {
      width: 100%;
      height: 28px;
      line-height: 2.8rem;
      font-size: ${props => props.theme.font.large};
      background: ${props => props.theme.color.secondaryBg};
      border-radius: 10px 10px 0 0;
    }
    &--txt {
      padding: 0 0 11px;
      color: ${props => props.theme.color.gray};
      font-size: ${props => props.theme.font.large};
      line-height: 1.8rem;
      &:nth-of-type(1) {
        padding: 11px 0;
      }
      * {
        font-size: ${props => props.theme.font.large};
      }
    }
  }
`
export const ListBtnStyle = (theme: Theme) => css`
  width: 100%;
  height: 30px;
  margin-bottom: 4px;
  background: ${theme.color.modalSubBg2};
  border-radius: 6px;
  transition: all 0.3s;
  line-height: 2rem;
  &::before {
    display: none;
  }
  /* 퀵 리그 선택 모달 */
  .category-name {
    float: left;
    width: 30%;
    color: ${theme.color.modalTxt};
  }
  .league-wrap {
    float: left;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
    width: calc(70% - 22px);
    /* 기타 - 종목 선택 */
    &.sport {
      width: calc(100% - 22px);
    }
    /* 리그 선택 */
    .league-name {
      float: left;
      width: calc(100% - 19px);
      color: ${theme.color.modalTxt};
    }
  }
  .emblem {
    width: 14px;
    height: auto;
    margin-right: 4px;
  }
  .top {
    position: relative;
    width: 30px;
    height: 15px;
    line-height: 1.5rem;
    font-size: ${theme.font.small};
    text-align: center;
    border-radius: 50px;
    background: #000;
  }

  /* 1폴드 가능 클럽 */
  &.one-fold-club {
    height: 42px;
    margin-bottom: 6px;
    .club-name {
      color: ${theme.color.modalTxt};
    }
    .club-visit {
      width: 60px;
      height: 24px;
      line-height: 2.4rem;
      border-radius: 50px;
      text-align: center;
      font-size: ${theme.font.small};
      background: ${theme.color.btn};
    }
  }

`
export const DropdownWrap = styled.span`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 30px;
  .club-select {
    z-index: 1;
    position: relative;
    margin-right: -14px;
  }
  .ant-select-dropdown {
    overflow: hidden;
  }
  .ant-select-dropdown-menu {
    max-height: 180px;
    overflow: auto;
  }
  .ant-select-selection {
    height: 30px;
    background: none;
    border: none;
    .ant-select-selection__rendered {
      line-height: 3rem;
      margin-left: 0;
      margin-right: 0;
      .ant-select-selection-selected-value {
        min-width: 70px;
        padding-right: 26px;
        text-align: right;
        .option-txt {
          font-size: ${props => props.theme.font.small};
        }
      }
    }
    // antd 화살표 아이콘
    .ant-select-arrow {
      display: none;
    }
  }
  .ant-select-focused .ant-select-selection, .ant-select-selection:focus, .ant-select-selection:active, .ant-select-selection:hover {
    box-shadow: none;
    background: none;
  }
  &.ant-select-open {
    & + .circle-down-ico {
      svg {
        transform: rotate(180deg);
      }
    }
  }
  .circle-down-ico {
    position: relative;
    width: 10px;
    height: 10px;
    svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      transition: .3s all;
      g {
        path#bg {
          fill: ${props => props.theme.color.modalSubBg2};
        }
        path#arrow {
          fill: ${props => props.theme.color.btn};
        }
      }
    }
    // 어두운 스타일의 드롭다운 버튼 (클럽이동팝업)
    &.dark {
      width: 14px;
      height: 14px;
      svg {
        g {
          path#bg {
            fill: ${props => props.theme.color.subColor2};
          }
          path#arrow {
            fill: ${props => props.theme.color.disableTxt2};
          }
        }
      }
    }
  }
  // 베팅 내역
  &.betting-history {
    margin-right: 0;
    margin-left: auto;
    .ant-select-selection .ant-select-selection__rendered .ant-select-selection-selected-value {
      min-width: 106px;
      padding-right: 20px;
      .option-txt {
        font-size: ${props => props.theme.font.medium};
      }
    }
    .ant-select-dropdown .ant-select-dropdown-menu .ant-select-dropdown-menu-item {
      .option-txt {
        font-size: ${props => props.theme.font.medium};
      }
    }
  }

  // 메인
  &.matchup {
    .circle-down-ico {
      width: 21px;
      height: 21px;
      transform: translateY(-1px);
      svg {
        transform: translate(-50%, -50%) rotate(90deg);
        #bg {
          fill: none;
        }
        #arrow {
          fill: ${props => props.theme.color.themeTxt};
        }
      }
    }
    .ant-select-selection .ant-select-selection__rendered .ant-select-selection-selected-value {
      min-width: auto;
      padding-right: 14px;
      .option-txt {
        font-size: ${props => props.theme.font.large};
      }
    }
    .ant-select-dropdown {
      min-width: 102px;
    }
    .ant-select-dropdown .ant-select-dropdown-menu .ant-select-dropdown-menu-item {
      padding: 0 12px !important;

      .option-txt {
        font-size: ${props => props.theme.font.medium};
      }
    }

    .ant-select-dropdown .ant-select-dropdown-menu .ant-select-dropdown-menu-item {
      height: 40px !important;
      line-height: 40px;
      background: #2C3340 !important;
    }
    .ant-select-dropdown .ant-select-dropdown-menu .ant-select-dropdown-menu-item.ant-select-dropdown-menu-item-active {
      background: ${props => props.theme.color.btn} !important;
      .option-txt {
        color: ${props => props.theme.color.themeTxt};
      }
    }
    .ant-select-dropdown .ant-select-dropdown-menu .ant-select-dropdown-menu-item.ant-select-dropdown-menu-item-selected {
      background: ${props => props.theme.color.underover} !important;
      .option-txt {
        color: ${props => props.theme.color.mainBg};
      }
    }
    &.pc-dropdown {
      .circle-down-ico {
        width: 27px;
        height: 27px;
      }
      .ant-select-dropdown {
        min-width: 115px;
      }
      .ant-select-selection .ant-select-selection__rendered .ant-select-selection-selected-value {
        .option-txt {
          font-size: ${props => props.theme.font.title};
        }
      }
      .ant-select-dropdown .ant-select-dropdown-menu .ant-select-dropdown-menu-item {
        .option-txt {
          font-size: ${props => props.theme.font.large};
        }
      }
    }
  }

  // 손실 한도 설정
  &.setting-popup {
    background: ${props => props.theme.color.modalBg};
    border-radius: 50px;
    .circle-down-ico {
      transform: translateX(-14px);
      margin-left: -10px;
      svg {
        width: 16px;
        path {
          &#bg {
            fill: ${props => props.theme.color.modalSubBg};
          }
          &#arrow {
            fill: ${props => props.theme.color.modalTxt};
          }
        }
      }
    }
    .ant-select {
      width: 102px;
      padding: 0 14px;
    }
    .ant-select-selection__placeholder {
      text-align: center;
      text-indent: 10px;
    }
    .ant-select-selection-selected-value {
      color: ${props => props.theme.color.modalTxt};
    }
    .ant-select-dropdown .ant-select-dropdown-menu .ant-select-dropdown-menu-item {
      line-height: 33px;
      background: ${props => props.theme.color.modalBg};
      text-align: center;
      &:not(:last-of-type) {
        border-bottom: 1px solid ${props => props.theme.color.modalSubBg} !important;
      }
      &.ant-select-dropdown-menu-item-selected {
        background: ${props => props.theme.color.modalSubBg} !important;
      }
      .option-txt {
        color: ${props => props.theme.color.modalTxt};
        font-size: ${props => props.theme.font.medium};
      }
    }
  }
  // 나도 승부사 정렬
  &.user-pick {
    z-index: 1;
    position: relative;
    display: inline-flex;
    width: 90px;
    .ant-select-selection {
      .ant-select-selection__rendered {
        .ant-select-selection-selected-value {
          min-width: 75px;
          padding-right: 20px;
          color: ${props => props.theme.color.modalSubBg}
        }
      }
    }
    .ant-select-dropdown-menu-item {
      font-size: 12px;
    }
    & > svg {
      z-index: -1;
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      width: 14px;
    }
  }
`
export const PageBgStyle = css`
  position: relative;
  width: 100%;
  overflow: hidden;
  img {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-47%, 0);
    width: auto;
    height: inherit;
  }
  &.club-portal-bg {
    height: 206px;
    margin-bottom: -206px;
    img {
      transform: translate(-50%, 0);
    }
  }
  &.betting-history-bg {
    height: 376px;
    margin-bottom: -376px;
  }
  &.my-info {
    height: 299px;
    margin-bottom: -299px;
    &.managed-user-bg {
      height: 333px;
      margin-bottom: -333px;
      z-index: 1;
      img {
        transform: translate(-50%, -39px);
      }
    }
  }
`
export const TermsWrap = styled.div`
  position: relative;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  height: auto;
  background: rgba(146, 146, 146, .1);
  &::before {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background: ${props => props.theme.color.btn};
    opacity: .3;
  }
  .terms-list {
    display: flex;
    flex-wrap: wrap;
    width: 250px;
    padding: 8px 9px;
    &--item {
      position: relative;
      width: auto;
      padding: 0 9px;
      &:not(&:nth-of-type(3n)) {
        &::before {
          content: '';
          display: block;
          position: absolute;
          top: 50%;
          right: 0;
          transform: translateY(-50%);
          width: 1px;
          height: 12px;
          background: ${props => props.theme.color.btn};
          opacity: .3;
        }
      }
      .link-btn {
        width: 100%;
        height: 27px;
        color: ${props => props.theme.color.modalDarkBg};
        font-size: ${props => props.theme.font.small};
        transition: all .15s;
        &:hover {
          color: ${props => props.theme.color.modalBg};
        }
      }
    }
  }
  &.terms-wrap-pc {
    .terms-list {
      width: 100%;
      &--item {
        &:not(&:last-of-type) {
          &::before {
            content: '';
            display: block;
            position: absolute;
            top: 50%;
            right: 0;
            transform: translateY(-50%);
            width: 1px;
            height: 12px;
            background: ${props => props.theme.color.btn};
            opacity: .3;
          }
        }
      }
    }
  }
`
export const CompanyRuleWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  width: 100%;
  height: auto;
  padding: 4px 11px 11px 11px;
  background: rgba(146, 146, 146, .1);
  img {
    image-rendering: -webkit-optimize-contrast; /* chrome(비표준) */
    image-rendering: crisp-edges;
  }
  &.pc-company-rule {
    padding: 0;
    margin-top: 6px;
    background: none;
  }
`
// const BubbleFadeInOutAni = keyframes`
//   0% {
//     opacity: 0;
//   }
//   4%, 86% {
//     opacity: 1;
//   }
//   89%, 100% {
//     opacity: 0;
//   }
// `
export const BubbleAlert = styled.div`
  z-index: 9;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  .bubble-contents {
    position: absolute;
    bottom: 63px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    width: auto;
    height: auto;
    padding: 14px;
    border-radius: 3px;
    background: ${props => props.theme.color.modalSubTxt};
    box-shadow: 0 6px 10px rgba(0, 0, 0, .16);
    &::after {
      content: '';
      display: block;
      position: absolute;
      bottom: -10px;
      right: 21%;
      border-top: 5px solid ${props => props.theme.color.modalSubTxt};
      border-bottom: 5px solid transparent;
      border-right: 5px solid transparent;
      border-left: 5px solid transparent;
    }
  }
  &.bet-alert {
    .bubble-contents {
      justify-content: center;
      align-items: center;
      width: calc(100% - 36px);
      height: auto;
      min-height: 46px;
      line-height: 1.8rem;
    }
  }
  &.bet-complete-alert {
    .bubble-contents {
      width: 243px;
      height: 95px;
      left: 24px;
      transform: translateX(0);
      background: ${props => props.theme.color.yellow};
      &::after {
        left: 66px;
        right: initial;
        border-top-color: ${props => props.theme.color.yellow};
      }
      img {
        width: 60px;
        margin-right: 10px;
        transform: translateY(2px);
      }
      .complete-txt {
        line-height: 2rem;
        color: ${props => props.theme.color.modalTxt};
        font-size: ${props => props.theme.font.large};
        .sub-txt {
          display: block;
          margin-top: 10px;
          line-height: 1.8rem;
          color: ${props => props.theme.color.modalSubTxt};
        }
      }
    }
  }
  &.message-alert {
    .bubble-contents {
      position: fixed;
      width: 184px;
      height: 68px;
      right: 24px;
      left: initial;
      bottom: initial;
      top: 42px;
      transform: translateX(0);
      align-items: center;
      background: ${props => props.theme.color.yellow};
      &::after {
        top: -10px;
        bottom: initial;
        border-top-color: transparent;
        border-bottom-color: ${props => props.theme.color.yellow};
      }
      .info-txt {
        line-height: 1.8rem;
        color: ${props => props.theme.color.modalTxt};
        text-align: left;
        transform: translateY(1px);
      }
    }
  }

  &.no-tail {
    .bubble-contents {
      bottom: 140px;
      &::after {
        display: none;
      }
    }
  }
  &.max-bet {
    .bubble-contents {
      display: flex;
      flex-flow: column;
    }
    &.pc {
      .bubble-contents {
        bottom: 175px;
      }
    }
  }
`
const brightListPadding = '21px'
const listInfoStyle = (props: ThemeProps) => css`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  .tit {
    ${TxtLimit};
    max-width: 100%;
    line-height: 1.6rem;
    color: ${props.theme.color.modalTxt};
    font-size: ${props.theme.font.large};
  }
  .date {
    ${TxtLimit};
    margin-top: 2px;
    color: ${props.theme.color.gray};
    font-weight: ${props.theme.fontW.medium};
  }
`
// 밝은 리스트 페이지
export const LightListWrap = styled.div`
  &.pc-bright-list-wrap {
    height: 100%;
    .am-list-view-scrollview {
      height: 100%;
    }
  }
  &:not(.pc-bright-list-wrap) {
    padding-bottom: ${NavBottomPadding};
  }
  .am-list-view-scrollview, .am-list {
    width: 100%;
  }
  .list-btn {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 64px;
    padding: 0 ${brightListPadding};
    border-top: 1px solid ${props => props.theme.color.modalSubBg};
    border-radius: 0;
    background: ${props => props.theme.color.modalBg};
    .list-info {
      ${listInfoStyle};
    }
    .main-tag {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: 40px;
      height: 24px;
      margin-right: 10px;
      background: ${props => props.theme.color.secondaryBg};
      border-radius: 4px;
      &.txt-icon {
        width: 39px;
        height: 20px;
        margin-right: 8px;
        border-radius: 0;
        background: ${props => props.theme.color.TP};
        display: inline-block;
        ::after {
          content: '주요';
          display: flex;
          align-items: center;
          justify-content: center;
          width: 39px;
          height: 20px;
          font-size: ${props => props.theme.font.medium};
          font-weight: ${props => props.theme.fontW.medium};
          color: ${props => props.theme.color.white};
          background: ${props => props.theme.color.secondaryBg};
          border-radius: 4px;
        }
      }
    }
    .list-badge {
      position: absolute;
      top: 14px;
      left: 12px;
    }
  }
  .bright-list {
    width: 100%;
    &--item {
      // 고정글
      &.fixed {
        .pin-ico {
          display: block;
        }
      }
    }
  }
`
// 밝은 리스트 상세 팝업
export const LightListDetailPopupWrap = styled.div`
  min-height: 100%;
  max-height: calc(100vh - 40px);
  background: ${props => props.theme.color.modalBg};
  overflow: auto;
  .list-info {
    ${listInfoStyle};
    align-items: center;
    padding: 25px 21px;
    border-bottom: 1px solid ${props => props.theme.color.modalSubBg};
    // 타이틀이 2줄까지 노출
    .tit {
      &.line-2 {
        ${TxtLimit2};
        line-height: 1.5rem;
        max-height: 2.9rem;
      }
    }
    &.row {
      flex-flow: row;
    }
    .main-tag {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: 40px;
      height: 24px;
      margin-right: 10px;
      background: ${props => props.theme.color.secondaryBg};
      border-radius: 4px;
    }
  }
  .list-contents {
    text-align: left;
    line-height: 12px;
    white-space: pre-line;
    padding: 14px;
    color: ${props => props.theme.color.modalTxt};
    & > p {
      max-width: 100%;
    }
    img {
      max-width: 100%;
      height: auto !important;
    }
    * {
      font-size: inherit;
      color: inherit;
      &:not(strong) {
        font-weight: ${props => props.theme.fontW.medium};
      }
    }
  }
  &.pc {
    max-height: 655px;
    padding: 14px;
  }
`
export const SwiperWrap = styled.div`
  display: block;
  width: 100%;

  // swiper common style
  .swiper {
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: hidden;
    list-style: none;
    padding: 0;
    height: auto;
    /* Fix of Webkit flickering */
    z-index: 1;
  }
  .swiper-container-vertical > .swiper-wrapper {
    flex-direction: column;
  }
  .swiper-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: flex;
    transition-property: transform;
    box-sizing: content-box;
  }
  .swiper-container-android .swiper-slide,
  .swiper-wrapper {
    transform: translate3d(0px, 0, 0);
  }
  .swiper-container-multirow > .swiper-wrapper {
    flex-wrap: wrap;
  }
  .swiper-container-multirow-column > .swiper-wrapper {
    flex-wrap: wrap;
    flex-direction: column;
  }
  .swiper-container-free-mode > .swiper-wrapper {
    transition-timing-function: ease-out;
    margin: 0 auto;
  }
  .swiper-slide {
    flex-shrink: 0;
    width: 100%;
    height: 100%;
    position: relative;
    transition-property: transform;
  }
  .swiper-slide-invisible-blank {
    visibility: hidden;
  }
  /* CSS Mode */
  .swiper-container-css-mode {
    > .swiper-wrapper {
      overflow: auto;
      scrollbar-width: none; /* For Firefox */
      -ms-overflow-style: none; /* For Internet Explorer and Edge */
      &::-webkit-scrollbar {
        display: none;
      }
    }
    > .swiper-wrapper > .swiper-slide {
      scroll-snap-align: start start;
    }
  }
  .swiper-container-horizontal.swiper-container-css-mode {
    > .swiper-wrapper {
      scroll-snap-type: x mandatory;
    }
  }
  .swiper-container-vertical.swiper-container-css-mode {
    > .swiper-wrapper {
      scroll-snap-type: y mandatory;
    }
  }
  /* Common Styles */
  .swiper-pagination-fraction,
  .swiper-pagination-custom,
  .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: 10px;
    left: 0;
    width: 100%;
  }
  //navigation
  .swiper-button-prev,
  .swiper-button-next {
    position: absolute;
    top: 50%;
    width: calc(44px / 44 * 27);
    height: 44px;
    margin-top: calc(-1 * 44px / 2);
    z-index: 10;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: blue;
    &.swiper-button-disabled {
      opacity: 0.1;
      cursor: auto;
      pointer-events: none;
    }
    &:hover {
      &::before, &::after {
        background: ${props => props.theme.color.white};
      }
    }
  }
  .swiper-button-prev, .swiper-button-next {
    z-index: 11;
    display: block;
    top: initial;
    bottom: 8px;
    height: 30px;
    background: none;
    transform: scale(.85);
  }
  .swiper-button-prev {
    left: initial;
    right: 62px;
    //border: 1px solid red;
    &::before, &::after {
      content: '';
      display: block;
      position: absolute;
      top: 11px;
      left: 7px;
      width: 10px;
      height: 2px;
      border-radius: 10px;
      background: ${props => props.theme.color.modalSubBg2};
      transform: rotate(135deg);
    }
    &::after {
      top: initial;
      bottom: 10px;
      transform: rotate(45deg);
    }
  }
  .swiper-button-next {
    right: 24px;
    &::before, &::after {
      content: '';
      display: block;
      position: absolute;
      top: 11px;
      right: 7px;
      width: 10px;
      height: 2px;
      border-radius: 10px;
      background: ${props => props.theme.color.modalBg};
      transform: rotate(-135deg);
    }
    &::after {
      top: initial;
      bottom: 10px;
      transform: rotate(-45deg);
    }
  }
  //.swiper-button-lock {
  //  display: none;
  //}
  // pagination
  .swiper-pagination {
    z-index: 10;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    bottom: 4px;
    left: initial;
    right: 14px;
    width: auto;
    min-width: 48px;
    height: 22px;
    transition: 300ms opacity;
    transform: translate3d(0, 0, 0);
    background: ${props => props.theme.color.subColor};
    opacity: .6;
    border-radius: 30px;
    font-size: 0;
    * {
      color: ${props => props.theme.color.TP};
    }
    &.swiper-pagination-hidden {
      opacity: 0;
    }
  }
  .swiper-pagination.swiper-pagination-fraction {
    width: 90px;
    height: 36px;
  }
  // 좌우 여백 18
  &.p-18 {
    .swiper {
      padding: 0 18px;
    }
  }
  // 우측 navigation
  &.right-navigation {
    .swiper-button-prev {
      left: 24px;
    }
    .swiper-button-next {
      left: 66px;
    }
    // pagination
    .swiper-pagination {
      left: 14px !important;
      right: initial;
    }
  }

  &.quick-swipe {
    display: flex;
    flex-wrap: nowrap;
    gap: 14px;
    width: 100%;
    height: auto;
    padding: 0 18px;
    overflow: auto;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .go-end-pick-btn, .go-end-sport-talk-btn {
    min-width: 90px;
    width: calc(185px / 2);
    height: 175px;
    line-height: 140%;
    border-radius: 18px;
    font-size: ${props => props.theme.font.large};
    background: ${props => props.theme.color.mainColor};
    &.pc {
      width: 50%;
    }
    svg {
      transform: rotate(-90deg) translate(2px, 2px);
      width: 12px;
    }
  }
  .go-end-sport-talk-btn {
    float: left;
    height: 133px;
    background: ${props => props.theme.color.subColor2};
  }
  &.today-pick-list, &.user-pick-list {
    margin-top: 9px;
    .swipe-item {
      min-width: 185px;
      width: 185px;
      &.closed-pick {
        min-width: 210px;
        width: 210px;
      }
    }
  }
  // 스크롤 생성
  &.scroll-view {
    height: 100%;
    overflow: auto;
  }
  &.home-banner {
    position: relative;
    z-index: 0;
  }
`
export const BottomBarCommonStyle = (props: ThemeProps) => css`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  min-height: ${NavH};
  padding-top: 2px;
  padding-bottom: ${SafeAreaEnvPadding};
  padding-bottom: ${SafeAreaConstantPadding};
  background: ${props.theme.color.mainBg};
  border-top: 1px solid rgba(45, 55, 69, .5);
`
export const EmoticonArea = styled.div`
  display: none;
  width: 100%;
  height: auto;
  background: ${props => props.theme.color.modalSubBg};
  z-index: 2;
  .emoticon-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 0;
    padding: 10px 12px;
    overflow: auto;
    ${preventScrollStyle}
    &--item {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 25%;
      padding: 3.3%;
      .emoticon-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: auto;
        height: auto;
        background: none;
        border-radius: 0;
        img {
          width: 100%;
          height: auto;
        }
      }
    }
    ${mqMin[2]} {
      &--item {
        width: 20%;
      }
    }
  }
  &.show {
    display: block;
    margin-top: -13px;
  }
  // 댓글 이모티콘 영역
  &.comment-emoticon {
    width: calc(100% + 28px);
    height: auto;
    margin-left: -14px;
    margin-bottom: -10px;
    margin-top: 9px;
    background: rgba(33, 39, 50, .5);
    border-radius: 0 0 9px 9px;
  }
`

export const CheerForTeamArea = styled.div`
  background: ${props => props.theme.color.TP};
  z-index: -1;
  overscroll-behavior: none;
  width: 100%;
  &:not(.pc) {
    position: fixed;
    height: calc(100% - 98px - 68px);
    top: 50%;
    left: 50%;
    transform: translate(-50%, calc(-50% + 15px));
  }
  .cheer-for-team-contents-wrap {
    position: absolute;
    width: 100%;
    height: 100%;
    bottom: 0;
    overflow: hidden;
    background: ${props => props.theme.color.TP};
    .cls-btn {
      position: absolute;
      top: 4px;
      right: 11px;
      width: 35px;
      height: 35px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 0;
      .x-ico {
        position: relative;
        display: block;
        width: 10px;
        height: 10px;
        transform: rotate(45deg);
        ::before {
          content: '';
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 2px;
          height: 15px;
          background: ${props => props.theme.color.modalgray};
          border-radius: 10px;
        }
        ::after {
          content: '';
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 15px;
          height: 2px;
          background: ${props => props.theme.color.modalgray};
          border-radius: 10px;
        }
      }
    }
    .cheer-for-team-contents {
      padding-top: 35px;
      height: 100%;
      width: 100%;
      overflow: hidden;
      background: ${props => props.theme.color.modalSubBg2};
      .cheer-for-team-tab {
        ::before {
          z-index: 1;
        }
        .am-tabs-top {
          background: ${props => props.theme.color.modalSubBg2};
          .am-tabs-tab-bar-wrap {
            width: calc(100% - 40px);
          }
        }
      }
      .filter-list {
        .am-list {
          padding: 14px 10px;
          max-width: 100%;
          .am-list-header {
            .cheering-tab-my-bet {
              height: 30px;
              margin: 0 0 9px 6px;
              .am-tabs-default-bar-content {
                padding: 0;
                .am-tabs-default-bar-tab {
                  padding: 0 9px 0 0;
                  height: 30px;
                  .tab-item {
                    height: 30px;
                    .txt {
                      color: ${props => props.theme.color.gray};
                    }
                    &::before {
                      opacity: 1;
                      border-color: ${props => props.theme.color.modalSubBg};
                    }
                  }
                }
                .am-tabs-default-bar-tab-active .tab-item {
                  .txt {
                    color: ${props => props.theme.color.themeTxt};
                  }
                  &::before {
                    background: ${props => props.theme.color.mainColor};
                  }
                }
              }
            }
          }
          .am-list-body {
            background: ${props => props.theme.color.TP};
          }
          .am-list-footer {
            > div > div {
              height: calc(100vh - 310px);
            }
          }
        }
      }
    }
  }
  &.is-emoticon { // 응원글 패널과 이모티콘 패널이 동시에 열렸을 때 (MO)
    height: calc(100% - 440px);
    transform: translate(-50%, calc(-50% + -122px));
  }
  &.pc {
    position: absolute;
    bottom: 109px;
    height: 438px;
    .favorite-btn {
      width: 99px;
      .favorite-btn-ele {
        left: 23px;
      }
    }
    .am-list-footer {
      > div > div {
        height: 255px !important;
        .empty-wrap {
          transform: translate(-50%, -50%);
        }
      }
    }
    &.is-emoticon { // 응원글 패널과 이모티콘 패널이 동시에 열렸을 때 (PC)
      bottom: calc(109px + -86px);
      left: 50%;
      height: calc(438px - 170px);
    }
  }
`
const PlusIcoProps = props => css`
  width: ${props.width}px;
  height: ${props.height}px;
  transform: scale(${props.scale});
  &::before, &::after {
    background: ${props.color};
  }
`
export const PlusIco = styled.span`
  position: relative;
  display: inline-block;
  &::before, &::after {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  &::before {
    width: 1px;
    height: 100%;
  }
  &::after {
    width: 100%;
    height: 1px;
  }
  ${PlusIcoProps};
`
// 프리미엄 분석가 댓글, 나도승부사 첨부 파일, 나도승부사 댓글
export const UploadImgPreviewCommonStyle = css`
  position: relative;
  width: auto;
  height: auto;
  max-height: 85px;
  margin: 12px 0 3px;
  .attachment-img-btn {
    z-index: 0;
    max-height: inherit;
    border-radius: 6px;
    overflow: hidden;
  }
  .upload-img-preview {
    width: auto;
    max-width: 100%;
    height: auto;
    max-height: inherit;
    &.emoticon {
      height: 78px;
    }
  }
  &:has(.is-fold) {
    max-height: inherit;
  }
`
export const PopupImgCommonStyle = css`
  width: 100%;
  height: auto;
  margin-bottom: 66px;
`
